// @generated by protobuf-ts 2.9.1 with parameter generate_dependencies
// @generated from protobuf file "api.proto" (package "proto", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { ItemSlot } from "./common";
import { ItemSpec } from "./common";
import { PseudoStat } from "./common";
import { Stat } from "./common";
import { Encounter } from "./common";
import { ActionID } from "./common";
import { UnitReference } from "./common";
import { Debuffs } from "./common";
import { RaidBuffs } from "./common";
import { PartyBuffs } from "./common";
import { SimDatabase } from "./common";
import { HealingModel } from "./common";
import { APLRotation } from "./apl";
import { Cooldowns } from "./common";
import { Profession } from "./common";
import { Glyphs } from "./common";
import { TankDeathknight } from "./deathknight";
import { Deathknight } from "./deathknight";
import { ProtectionWarrior } from "./warrior";
import { Warrior } from "./warrior";
import { Warlock } from "./warlock";
import { RestorationShaman } from "./shaman";
import { EnhancementShaman } from "./shaman";
import { ElementalShaman } from "./shaman";
import { Rogue } from "./rogue";
import { SmitePriest } from "./priest";
import { ShadowPriest } from "./priest";
import { HealingPriest } from "./priest";
import { HolyPaladin } from "./paladin";
import { ProtectionPaladin } from "./paladin";
import { RetributionPaladin } from "./paladin";
import { Mage } from "./mage";
import { Hunter } from "./hunter";
import { RestorationDruid } from "./druid";
import { FeralTankDruid } from "./druid";
import { FeralDruid } from "./druid";
import { BalanceDruid } from "./druid";
import { IndividualBuffs } from "./common";
import { UnitStats } from "./common";
import { Consumes } from "./common";
import { EquipmentSpec } from "./common";
import { ShattrathFaction } from "./common";
import { Class } from "./common";
import { Race } from "./common";
/**
 * @generated from protobuf message proto.Player
 */
export interface Player {
    /**
     * Label used for logging.
     *
     * @generated from protobuf field: string name = 16;
     */
    name: string;
    /**
     * @generated from protobuf field: proto.Race race = 1;
     */
    race: Race;
    /**
     * @generated from protobuf field: proto.Class class = 2;
     */
    class: Class;
    /**
     * @generated from protobuf field: proto.ShattrathFaction shatt_faction = 24;
     */
    shattFaction: ShattrathFaction;
    /**
     * @generated from protobuf field: proto.EquipmentSpec equipment = 3;
     */
    equipment?: EquipmentSpec;
    /**
     * @generated from protobuf field: proto.Consumes consumes = 4;
     */
    consumes?: Consumes;
    /**
     * @generated from protobuf field: proto.UnitStats bonus_stats = 36;
     */
    bonusStats?: UnitStats;
    /**
     * @generated from protobuf field: proto.IndividualBuffs buffs = 15;
     */
    buffs?: IndividualBuffs;
    /**
     * @generated from protobuf oneof: spec
     */
    spec: {
        oneofKind: "balanceDruid";
        /**
         * @generated from protobuf field: proto.BalanceDruid balance_druid = 6;
         */
        balanceDruid: BalanceDruid;
    } | {
        oneofKind: "feralDruid";
        /**
         * @generated from protobuf field: proto.FeralDruid feral_druid = 22;
         */
        feralDruid: FeralDruid;
    } | {
        oneofKind: "feralTankDruid";
        /**
         * @generated from protobuf field: proto.FeralTankDruid feral_tank_druid = 26;
         */
        feralTankDruid: FeralTankDruid;
    } | {
        oneofKind: "restorationDruid";
        /**
         * @generated from protobuf field: proto.RestorationDruid restoration_druid = 37;
         */
        restorationDruid: RestorationDruid;
    } | {
        oneofKind: "hunter";
        /**
         * @generated from protobuf field: proto.Hunter hunter = 7;
         */
        hunter: Hunter;
    } | {
        oneofKind: "mage";
        /**
         * @generated from protobuf field: proto.Mage mage = 8;
         */
        mage: Mage;
    } | {
        oneofKind: "retributionPaladin";
        /**
         * @generated from protobuf field: proto.RetributionPaladin retribution_paladin = 9;
         */
        retributionPaladin: RetributionPaladin;
    } | {
        oneofKind: "protectionPaladin";
        /**
         * @generated from protobuf field: proto.ProtectionPaladin protection_paladin = 25;
         */
        protectionPaladin: ProtectionPaladin;
    } | {
        oneofKind: "holyPaladin";
        /**
         * @generated from protobuf field: proto.HolyPaladin holy_paladin = 38;
         */
        holyPaladin: HolyPaladin;
    } | {
        oneofKind: "healingPriest";
        /**
         * @generated from protobuf field: proto.HealingPriest healing_priest = 34;
         */
        healingPriest: HealingPriest;
    } | {
        oneofKind: "shadowPriest";
        /**
         * @generated from protobuf field: proto.ShadowPriest shadow_priest = 10;
         */
        shadowPriest: ShadowPriest;
    } | {
        oneofKind: "smitePriest";
        /**
         * @generated from protobuf field: proto.SmitePriest smite_priest = 20;
         */
        smitePriest: SmitePriest;
    } | {
        oneofKind: "rogue";
        /**
         * @generated from protobuf field: proto.Rogue rogue = 11;
         */
        rogue: Rogue;
    } | {
        oneofKind: "elementalShaman";
        /**
         * @generated from protobuf field: proto.ElementalShaman elemental_shaman = 12;
         */
        elementalShaman: ElementalShaman;
    } | {
        oneofKind: "enhancementShaman";
        /**
         * @generated from protobuf field: proto.EnhancementShaman enhancement_shaman = 18;
         */
        enhancementShaman: EnhancementShaman;
    } | {
        oneofKind: "restorationShaman";
        /**
         * @generated from protobuf field: proto.RestorationShaman restoration_shaman = 39;
         */
        restorationShaman: RestorationShaman;
    } | {
        oneofKind: "warlock";
        /**
         * @generated from protobuf field: proto.Warlock warlock = 13;
         */
        warlock: Warlock;
    } | {
        oneofKind: "warrior";
        /**
         * @generated from protobuf field: proto.Warrior warrior = 14;
         */
        warrior: Warrior;
    } | {
        oneofKind: "protectionWarrior";
        /**
         * @generated from protobuf field: proto.ProtectionWarrior protection_warrior = 21;
         */
        protectionWarrior: ProtectionWarrior;
    } | {
        oneofKind: "deathknight";
        /**
         * @generated from protobuf field: proto.Deathknight deathknight = 31;
         */
        deathknight: Deathknight;
    } | {
        oneofKind: "tankDeathknight";
        /**
         * @generated from protobuf field: proto.TankDeathknight tank_deathknight = 32;
         */
        tankDeathknight: TankDeathknight;
    } | {
        oneofKind: undefined;
    };
    /**
     * Talents in wowhead format, e.g. '01102123133-12312312-'
     *
     * @generated from protobuf field: string talents_string = 17;
     */
    talentsString: string;
    /**
     * @generated from protobuf field: proto.Glyphs glyphs = 28;
     */
    glyphs?: Glyphs;
    /**
     * @generated from protobuf field: proto.Profession profession1 = 29;
     */
    profession1: Profession;
    /**
     * @generated from protobuf field: proto.Profession profession2 = 30;
     */
    profession2: Profession;
    /**
     * @generated from protobuf field: proto.Cooldowns cooldowns = 19;
     */
    cooldowns?: Cooldowns;
    /**
     * @generated from protobuf field: proto.APLRotation rotation = 40;
     */
    rotation?: APLRotation;
    /**
     * @generated from protobuf field: int32 reaction_time_ms = 41;
     */
    reactionTimeMs: number;
    /**
     * @generated from protobuf field: int32 channel_clip_delay_ms = 42;
     */
    channelClipDelayMs: number;
    /**
     * @generated from protobuf field: bool in_front_of_target = 23;
     */
    inFrontOfTarget: boolean;
    /**
     * @generated from protobuf field: double distance_from_target = 33;
     */
    distanceFromTarget: number;
    /**
     * @generated from protobuf field: proto.HealingModel healing_model = 27;
     */
    healingModel?: HealingModel;
    /**
     * Items/enchants/gems/etc to include in the database.
     *
     * @generated from protobuf field: proto.SimDatabase database = 35;
     */
    database?: SimDatabase;
}
/**
 * @generated from protobuf message proto.Party
 */
export interface Party {
    /**
     * @generated from protobuf field: repeated proto.Player players = 1;
     */
    players: Player[];
    /**
     * @generated from protobuf field: proto.PartyBuffs buffs = 2;
     */
    buffs?: PartyBuffs;
}
/**
 * @generated from protobuf message proto.Raid
 */
export interface Raid {
    /**
     * @generated from protobuf field: repeated proto.Party parties = 1;
     */
    parties: Party[];
    /**
     * The number of parties in the raid who participate in the sim, e.g.
     * 10-man vs 25-man raids. The remaining parties are unused but can hold
     * bench players.
     *
     * If this value is 0, all parties are included.
     *
     * @generated from protobuf field: int32 num_active_parties = 2;
     */
    numActiveParties: number;
    /**
     * @generated from protobuf field: proto.RaidBuffs buffs = 7;
     */
    buffs?: RaidBuffs;
    /**
     * Extra debuffs provided by buff bots in this raid.
     * This is also used for debuffs in the individual sims.
     *
     * @generated from protobuf field: proto.Debuffs debuffs = 5;
     */
    debuffs?: Debuffs;
    /**
     * Players who will be tanking mobs.
     *
     * @generated from protobuf field: repeated proto.UnitReference tanks = 4;
     */
    tanks: UnitReference[];
    /**
     * Staggers Stormstrike casts across Enhance Shaman to maximize charge usage.
     *
     * @generated from protobuf field: bool stagger_stormstrikes = 3;
     */
    staggerStormstrikes: boolean;
    /**
     * Extra fake players to add. Currently only used by healing sims.
     *
     * @generated from protobuf field: int32 target_dummies = 6;
     */
    targetDummies: number;
}
/**
 * @generated from protobuf message proto.SimOptions
 */
export interface SimOptions {
    /**
     * @generated from protobuf field: int32 iterations = 1;
     */
    iterations: number;
    /**
     * @generated from protobuf field: int64 random_seed = 2;
     */
    randomSeed: bigint;
    /**
     * @generated from protobuf field: bool debug = 3;
     */
    debug: boolean; // Enables debug logging.    /**
     * @generated from protobuf field: bool debug_first_iteration = 6;
     */
    debugFirstIteration: boolean;
    /**
     * @generated from protobuf field: bool is_test = 5;
     */
    isTest: boolean; // Only used internally.    /**
     * @generated from protobuf field: bool save_all_values = 7;
     */
    saveAllValues: boolean; // Only used internally.    /**
     * @generated from protobuf field: bool interactive = 8;
     */
    interactive: boolean; // Enables interactive mode.}
/**
 * The aggregated results from all uses of a particular action.
 *
 * @generated from protobuf message proto.ActionMetrics
 */
export interface ActionMetrics {
    /**
     * @generated from protobuf field: proto.ActionID id = 1;
     */
    id?: ActionID;
    /**
     * True if a melee action, false if a spell action.
     *
     * @generated from protobuf field: bool is_melee = 2;
     */
    isMelee: boolean;
    /**
     * Metrics for this action for each target.
     * Note that some spells are untargeted, these will always have a single
     * element in this array.
     *
     * @generated from protobuf field: repeated proto.TargetedActionMetrics targets = 3;
     */
    targets: TargetedActionMetrics[];
}
/**
 * Metrics for a specific action, when cast at a particular target.
 *
 * @generated from protobuf message proto.TargetedActionMetrics
 */
export interface TargetedActionMetrics {
    /**
     * Raid/Target Index of the unit these metrics are targeted at.
     *
     * @generated from protobuf field: int32 unit_index = 12;
     */
    unitIndex: number;
    /**
     * # of times this action was used by the agent.
     *
     * @generated from protobuf field: int32 casts = 1;
     */
    casts: number;
    /**
     * # of times this action hit a target. For cleave spells this can be larger than casts.
     *
     * @generated from protobuf field: int32 hits = 2;
     */
    hits: number;
    /**
     * # of times this action was a critical strike.
     *
     * @generated from protobuf field: int32 crits = 3;
     */
    crits: number;
    /**
     * # of times this action was a Miss or Resist.
     *
     * @generated from protobuf field: int32 misses = 4;
     */
    misses: number;
    /**
     * # of times this action was a Dodge.
     *
     * @generated from protobuf field: int32 dodges = 5;
     */
    dodges: number;
    /**
     * # of times this action was a Parry.
     *
     * @generated from protobuf field: int32 parries = 6;
     */
    parries: number;
    /**
     * # of times this action was a Block.
     *
     * @generated from protobuf field: int32 blocks = 7;
     */
    blocks: number;
    /**
     * # of times this action was a Glance.
     *
     * @generated from protobuf field: int32 glances = 8;
     */
    glances: number;
    /**
     * Total damage done to this target by this action.
     *
     * @generated from protobuf field: double damage = 9;
     */
    damage: number;
    /**
     * Total threat done to this target by this action.
     *
     * @generated from protobuf field: double threat = 10;
     */
    threat: number;
    /**
     * Total healing done to this target by this action.
     *
     * @generated from protobuf field: double healing = 11;
     */
    healing: number;
    /**
     * Total shielding done to this target by this action.
     *
     * @generated from protobuf field: double shielding = 13;
     */
    shielding: number;
    /**
     * Total time spent casting this action, in milliseconds, either from hard casts, GCD, or channeling.
     *
     * @generated from protobuf field: double cast_time_ms = 14;
     */
    castTimeMs: number;
}
/**
 * @generated from protobuf message proto.AuraMetrics
 */
export interface AuraMetrics {
    /**
     * @generated from protobuf field: proto.ActionID id = 1;
     */
    id?: ActionID;
    /**
     * @generated from protobuf field: double uptime_seconds_avg = 2;
     */
    uptimeSecondsAvg: number;
    /**
     * @generated from protobuf field: double uptime_seconds_stdev = 3;
     */
    uptimeSecondsStdev: number;
    /**
     * @generated from protobuf field: double procs_avg = 4;
     */
    procsAvg: number;
}
/**
 * @generated from protobuf message proto.ResourceMetrics
 */
export interface ResourceMetrics {
    /**
     * @generated from protobuf field: proto.ActionID id = 1;
     */
    id?: ActionID;
    /**
     * @generated from protobuf field: proto.ResourceType type = 2;
     */
    type: ResourceType;
    /**
     * # of times this action was used by the agent.
     *
     * @generated from protobuf field: int32 events = 3;
     */
    events: number;
    /**
     * Total resource gain from this action. Will be negative for spend actions.
     *
     * @generated from protobuf field: double gain = 4;
     */
    gain: number;
    /**
     * Like gain, but doesn't include gains over resource cap.
     *
     * @generated from protobuf field: double actual_gain = 5;
     */
    actualGain: number;
}
/**
 * @generated from protobuf message proto.DistributionMetrics
 */
export interface DistributionMetrics {
    /**
     * @generated from protobuf field: double avg = 1;
     */
    avg: number;
    /**
     * @generated from protobuf field: double stdev = 2;
     */
    stdev: number;
    /**
     * @generated from protobuf field: double max = 3;
     */
    max: number;
    /**
     * @generated from protobuf field: int64 max_seed = 5;
     */
    maxSeed: bigint;
    /**
     * @generated from protobuf field: double min = 6;
     */
    min: number;
    /**
     * @generated from protobuf field: int64 min_seed = 7;
     */
    minSeed: bigint;
    /**
     * @generated from protobuf field: map<int32, int32> hist = 4;
     */
    hist: {
        [key: number]: number;
    };
    /**
     * @generated from protobuf field: repeated double all_values = 8;
     */
    allValues: number[];
}
/**
 * All the results for a single Unit (player, target, or pet).
 *
 * @generated from protobuf message proto.UnitMetrics
 */
export interface UnitMetrics {
    /**
     * @generated from protobuf field: string name = 9;
     */
    name: string;
    /**
     * @generated from protobuf field: int32 unit_index = 13;
     */
    unitIndex: number;
    /**
     * @generated from protobuf field: proto.DistributionMetrics dps = 1;
     */
    dps?: DistributionMetrics;
    /**
     * @generated from protobuf field: proto.DistributionMetrics dpasp = 16;
     */
    dpasp?: DistributionMetrics;
    /**
     * @generated from protobuf field: proto.DistributionMetrics threat = 8;
     */
    threat?: DistributionMetrics;
    /**
     * @generated from protobuf field: proto.DistributionMetrics dtps = 11;
     */
    dtps?: DistributionMetrics;
    /**
     * @generated from protobuf field: proto.DistributionMetrics tmi = 17;
     */
    tmi?: DistributionMetrics;
    /**
     * @generated from protobuf field: proto.DistributionMetrics hps = 14;
     */
    hps?: DistributionMetrics;
    /**
     * @generated from protobuf field: proto.DistributionMetrics tto = 15;
     */
    tto?: DistributionMetrics; // Time To OOM, in seconds.    /**
     * average seconds spent oom per iteration
     *
     * @generated from protobuf field: double seconds_oom_avg = 3;
     */
    secondsOomAvg: number;
    /**
     * Chance (0-1) representing probability of death. Used for tank sims.
     *
     * @generated from protobuf field: double chance_of_death = 12;
     */
    chanceOfDeath: number;
    /**
     * @generated from protobuf field: repeated proto.ActionMetrics actions = 5;
     */
    actions: ActionMetrics[];
    /**
     * @generated from protobuf field: repeated proto.AuraMetrics auras = 6;
     */
    auras: AuraMetrics[];
    /**
     * @generated from protobuf field: repeated proto.ResourceMetrics resources = 10;
     */
    resources: ResourceMetrics[];
    /**
     * @generated from protobuf field: repeated proto.UnitMetrics pets = 7;
     */
    pets: UnitMetrics[];
}
/**
 * Results for a whole raid.
 *
 * @generated from protobuf message proto.PartyMetrics
 */
export interface PartyMetrics {
    /**
     * @generated from protobuf field: proto.DistributionMetrics dps = 1;
     */
    dps?: DistributionMetrics;
    /**
     * @generated from protobuf field: proto.DistributionMetrics hps = 3;
     */
    hps?: DistributionMetrics;
    /**
     * @generated from protobuf field: repeated proto.UnitMetrics players = 2;
     */
    players: UnitMetrics[];
}
/**
 * Results for a whole raid.
 *
 * @generated from protobuf message proto.RaidMetrics
 */
export interface RaidMetrics {
    /**
     * @generated from protobuf field: proto.DistributionMetrics dps = 1;
     */
    dps?: DistributionMetrics;
    /**
     * @generated from protobuf field: proto.DistributionMetrics hps = 3;
     */
    hps?: DistributionMetrics;
    /**
     * @generated from protobuf field: repeated proto.PartyMetrics parties = 2;
     */
    parties: PartyMetrics[];
}
/**
 * @generated from protobuf message proto.EncounterMetrics
 */
export interface EncounterMetrics {
    /**
     * @generated from protobuf field: repeated proto.UnitMetrics targets = 1;
     */
    targets: UnitMetrics[];
}
/**
 * RPC RaidSim
 *
 * @generated from protobuf message proto.RaidSimRequest
 */
export interface RaidSimRequest {
    /**
     * @generated from protobuf field: proto.Raid raid = 1;
     */
    raid?: Raid;
    /**
     * @generated from protobuf field: proto.Encounter encounter = 2;
     */
    encounter?: Encounter;
    /**
     * @generated from protobuf field: proto.SimOptions sim_options = 3;
     */
    simOptions?: SimOptions;
}
/**
 * Result from running the raid sim.
 *
 * @generated from protobuf message proto.RaidSimResult
 */
export interface RaidSimResult {
    /**
     * @generated from protobuf field: proto.RaidMetrics raid_metrics = 1;
     */
    raidMetrics?: RaidMetrics;
    /**
     * @generated from protobuf field: proto.EncounterMetrics encounter_metrics = 2;
     */
    encounterMetrics?: EncounterMetrics;
    /**
     * @generated from protobuf field: string logs = 3;
     */
    logs: string;
    /**
     * Needed for displaying the timeline properly when the duration +/- option
     * is used.
     *
     * @generated from protobuf field: double first_iteration_duration = 4;
     */
    firstIterationDuration: number;
    /**
     * @generated from protobuf field: double avg_iteration_duration = 6;
     */
    avgIterationDuration: number;
    /**
     * @generated from protobuf field: string error_result = 5;
     */
    errorResult: string;
}
/**
 * RPC ComputeStats
 *
 * @generated from protobuf message proto.ComputeStatsRequest
 */
export interface ComputeStatsRequest {
    /**
     * @generated from protobuf field: proto.Raid raid = 1;
     */
    raid?: Raid;
    /**
     * @generated from protobuf field: proto.Encounter encounter = 2;
     */
    encounter?: Encounter;
}
/**
 * @generated from protobuf message proto.AuraStats
 */
export interface AuraStats {
    /**
     * @generated from protobuf field: proto.ActionID id = 1;
     */
    id?: ActionID;
    /**
     * @generated from protobuf field: int32 max_stacks = 2;
     */
    maxStacks: number;
    /**
     * @generated from protobuf field: bool has_icd = 3;
     */
    hasIcd: boolean;
    /**
     * @generated from protobuf field: bool has_exclusive_effect = 4;
     */
    hasExclusiveEffect: boolean;
}
/**
 * @generated from protobuf message proto.SpellStats
 */
export interface SpellStats {
    /**
     * @generated from protobuf field: proto.ActionID id = 1;
     */
    id?: ActionID;
    /**
     * @generated from protobuf field: bool is_castable = 2;
     */
    isCastable: boolean; // Whether this spell may be cast by the APL logic.    /**
     * @generated from protobuf field: bool is_channeled = 7;
     */
    isChanneled: boolean; // Whether this spell is a channeled spell (Mind Flay, Drain Soul, etc).    /**
     * @generated from protobuf field: bool is_major_cooldown = 3;
     */
    isMajorCooldown: boolean; // Whether this spell is a major cooldown.    /**
     * @generated from protobuf field: bool has_dot = 4;
     */
    hasDot: boolean; // Whether this spell applies a DoT effect.    /**
     * @generated from protobuf field: bool has_shield = 6;
     */
    hasShield: boolean; // Whether this spell applies a shield effect.    /**
     * @generated from protobuf field: bool prepull_only = 5;
     */
    prepullOnly: boolean; // Whether this spell may only be cast during prepull.}
/**
 * @generated from protobuf message proto.APLActionStats
 */
export interface APLActionStats {
    /**
     * @generated from protobuf field: repeated string warnings = 1;
     */
    warnings: string[];
}
/**
 * @generated from protobuf message proto.APLStats
 */
export interface APLStats {
    /**
     * @generated from protobuf field: repeated proto.APLActionStats prepull_actions = 1;
     */
    prepullActions: APLActionStats[];
    /**
     * @generated from protobuf field: repeated proto.APLActionStats priority_list = 2;
     */
    priorityList: APLActionStats[];
}
/**
 * @generated from protobuf message proto.UnitMetadata
 */
export interface UnitMetadata {
    /**
     * @generated from protobuf field: string name = 3;
     */
    name: string;
    /**
     * @generated from protobuf field: repeated proto.SpellStats spells = 1;
     */
    spells: SpellStats[];
    /**
     * @generated from protobuf field: repeated proto.AuraStats auras = 2;
     */
    auras: AuraStats[];
}
/**
 * @generated from protobuf message proto.PetStats
 */
export interface PetStats {
    /**
     * @generated from protobuf field: proto.UnitMetadata metadata = 1;
     */
    metadata?: UnitMetadata;
}
/**
 * @generated from protobuf message proto.PlayerStats
 */
export interface PlayerStats {
    /**
     * Stats
     *
     * @generated from protobuf field: proto.UnitStats base_stats = 6;
     */
    baseStats?: UnitStats;
    /**
     * @generated from protobuf field: proto.UnitStats gear_stats = 1;
     */
    gearStats?: UnitStats;
    /**
     * @generated from protobuf field: proto.UnitStats talents_stats = 7;
     */
    talentsStats?: UnitStats;
    /**
     * @generated from protobuf field: proto.UnitStats buffs_stats = 8;
     */
    buffsStats?: UnitStats;
    /**
     * @generated from protobuf field: proto.UnitStats consumes_stats = 9;
     */
    consumesStats?: UnitStats;
    /**
     * @generated from protobuf field: proto.UnitStats final_stats = 2;
     */
    finalStats?: UnitStats;
    /**
     * @generated from protobuf field: repeated string sets = 3;
     */
    sets: string[];
    /**
     * @generated from protobuf field: proto.IndividualBuffs buffs = 4;
     */
    buffs?: IndividualBuffs;
    /**
     * @generated from protobuf field: proto.UnitMetadata metadata = 10;
     */
    metadata?: UnitMetadata;
    /**
     * @generated from protobuf field: proto.APLStats rotation_stats = 12;
     */
    rotationStats?: APLStats;
    /**
     * @generated from protobuf field: repeated proto.PetStats pets = 11;
     */
    pets: PetStats[];
}
/**
 * @generated from protobuf message proto.PartyStats
 */
export interface PartyStats {
    /**
     * @generated from protobuf field: repeated proto.PlayerStats players = 1;
     */
    players: PlayerStats[];
}
/**
 * @generated from protobuf message proto.RaidStats
 */
export interface RaidStats {
    /**
     * @generated from protobuf field: repeated proto.PartyStats parties = 1;
     */
    parties: PartyStats[];
}
/**
 * @generated from protobuf message proto.TargetStats
 */
export interface TargetStats {
    /**
     * @generated from protobuf field: proto.UnitMetadata metadata = 1;
     */
    metadata?: UnitMetadata;
}
/**
 * @generated from protobuf message proto.EncounterStats
 */
export interface EncounterStats {
    /**
     * @generated from protobuf field: repeated proto.TargetStats targets = 1;
     */
    targets: TargetStats[];
}
/**
 * @generated from protobuf message proto.ComputeStatsResult
 */
export interface ComputeStatsResult {
    /**
     * @generated from protobuf field: proto.RaidStats raid_stats = 1;
     */
    raidStats?: RaidStats;
    /**
     * @generated from protobuf field: proto.EncounterStats encounter_stats = 3;
     */
    encounterStats?: EncounterStats;
    /**
     * @generated from protobuf field: string error_result = 2;
     */
    errorResult: string;
}
/**
 * RPC StatWeights
 *
 * @generated from protobuf message proto.StatWeightsRequest
 */
export interface StatWeightsRequest {
    /**
     * @generated from protobuf field: proto.Player player = 1;
     */
    player?: Player;
    /**
     * @generated from protobuf field: proto.RaidBuffs raid_buffs = 2;
     */
    raidBuffs?: RaidBuffs;
    /**
     * @generated from protobuf field: proto.PartyBuffs party_buffs = 3;
     */
    partyBuffs?: PartyBuffs;
    /**
     * @generated from protobuf field: proto.Debuffs debuffs = 9;
     */
    debuffs?: Debuffs;
    /**
     * @generated from protobuf field: proto.Encounter encounter = 4;
     */
    encounter?: Encounter;
    /**
     * @generated from protobuf field: proto.SimOptions sim_options = 5;
     */
    simOptions?: SimOptions;
    /**
     * @generated from protobuf field: repeated proto.UnitReference tanks = 8;
     */
    tanks: UnitReference[];
    /**
     * @generated from protobuf field: repeated proto.Stat stats_to_weigh = 6;
     */
    statsToWeigh: Stat[];
    /**
     * @generated from protobuf field: repeated proto.PseudoStat pseudo_stats_to_weigh = 10;
     */
    pseudoStatsToWeigh: PseudoStat[];
    /**
     * @generated from protobuf field: proto.Stat ep_reference_stat = 7;
     */
    epReferenceStat: Stat;
}
/**
 * @generated from protobuf message proto.StatWeightsResult
 */
export interface StatWeightsResult {
    /**
     * @generated from protobuf field: proto.StatWeightValues dps = 1;
     */
    dps?: StatWeightValues;
    /**
     * @generated from protobuf field: proto.StatWeightValues hps = 4;
     */
    hps?: StatWeightValues;
    /**
     * @generated from protobuf field: proto.StatWeightValues tps = 2;
     */
    tps?: StatWeightValues;
    /**
     * @generated from protobuf field: proto.StatWeightValues dtps = 3;
     */
    dtps?: StatWeightValues;
    /**
     * @generated from protobuf field: proto.StatWeightValues tmi = 5;
     */
    tmi?: StatWeightValues;
    /**
     * @generated from protobuf field: proto.StatWeightValues p_death = 6;
     */
    pDeath?: StatWeightValues;
}
/**
 * @generated from protobuf message proto.StatWeightValues
 */
export interface StatWeightValues {
    /**
     * @generated from protobuf field: proto.UnitStats weights = 1;
     */
    weights?: UnitStats;
    /**
     * @generated from protobuf field: proto.UnitStats weights_stdev = 2;
     */
    weightsStdev?: UnitStats;
    /**
     * @generated from protobuf field: proto.UnitStats ep_values = 3;
     */
    epValues?: UnitStats;
    /**
     * @generated from protobuf field: proto.UnitStats ep_values_stdev = 4;
     */
    epValuesStdev?: UnitStats;
}
/**
 * @generated from protobuf message proto.AsyncAPIResult
 */
export interface AsyncAPIResult {
    /**
     * @generated from protobuf field: string progress_id = 1;
     */
    progressId: string;
}
/**
 * ProgressMetrics are used by all async APIs
 *
 * @generated from protobuf message proto.ProgressMetrics
 */
export interface ProgressMetrics {
    /**
     * @generated from protobuf field: int32 completed_iterations = 1;
     */
    completedIterations: number;
    /**
     * @generated from protobuf field: int32 total_iterations = 2;
     */
    totalIterations: number;
    /**
     * @generated from protobuf field: int32 completed_sims = 3;
     */
    completedSims: number;
    /**
     * @generated from protobuf field: int32 total_sims = 4;
     */
    totalSims: number;
    /**
     * @generated from protobuf field: bool presim_running = 8;
     */
    presimRunning: boolean;
    /**
     * Partial Results
     *
     * @generated from protobuf field: double dps = 5;
     */
    dps: number;
    /**
     * @generated from protobuf field: double hps = 9;
     */
    hps: number;
    /**
     * Final Results
     *
     * @generated from protobuf field: proto.RaidSimResult final_raid_result = 6;
     */
    finalRaidResult?: RaidSimResult; // only set when completed    /**
     * @generated from protobuf field: proto.StatWeightsResult final_weight_result = 7;
     */
    finalWeightResult?: StatWeightsResult;
    /**
     * @generated from protobuf field: proto.BulkSimResult final_bulk_result = 10;
     */
    finalBulkResult?: BulkSimResult;
}
/**
 * RPC: BulkSim
 *
 * @generated from protobuf message proto.BulkSimRequest
 */
export interface BulkSimRequest {
    /**
     * @generated from protobuf field: proto.RaidSimRequest base_settings = 1;
     */
    baseSettings?: RaidSimRequest;
    /**
     * @generated from protobuf field: proto.BulkSettings bulk_settings = 2;
     */
    bulkSettings?: BulkSettings;
}
/**
 * @generated from protobuf message proto.BulkSettings
 */
export interface BulkSettings {
    /**
     * @generated from protobuf field: repeated proto.ItemSpec items = 1;
     */
    items: ItemSpec[];
    /**
     * @generated from protobuf field: bool combinations = 2;
     */
    combinations: boolean;
    /**
     * @generated from protobuf field: bool fast_mode = 3;
     */
    fastMode: boolean; // Used to run with less iterations to start and slowly increase to weed out items faster.    /**
     * Use current enchant on the slot if not specified by the ItemSpec.
     * Only works when replacement item is valid target for enchant.
     *
     * @generated from protobuf field: bool auto_enchant = 4;
     */
    autoEnchant: boolean;
    /**
     * Currently not used.
     * Used to fill out gem slots that are not filled in the ItemSpec
     *
     * @generated from protobuf field: bool auto_gem = 5;
     */
    autoGem: boolean;
    /**
     * @generated from protobuf field: int32 default_red_gem = 6;
     */
    defaultRedGem: number;
    /**
     * @generated from protobuf field: int32 default_blue_gem = 7;
     */
    defaultBlueGem: number;
    /**
     * @generated from protobuf field: int32 default_yellow_gem = 8;
     */
    defaultYellowGem: number;
    /**
     * @generated from protobuf field: int32 default_meta_gem = 9;
     */
    defaultMetaGem: number;
    /**
     * @generated from protobuf field: bool ensure_meta_req_met = 10;
     */
    ensureMetaReqMet: boolean; // ensures that meta requirements are met when auto-gemming.    /**
     * Number of iterations per combo.
     * If set to 0 the sim core decides the optimal iterations.
     *
     * @generated from protobuf field: int32 iterations_per_combo = 11;
     */
    iterationsPerCombo: number;
}
/**
 * @generated from protobuf message proto.BulkSimResult
 */
export interface BulkSimResult {
    /**
     * @generated from protobuf field: repeated proto.BulkComboResult results = 1;
     */
    results: BulkComboResult[];
    /**
     * @generated from protobuf field: proto.BulkComboResult equipped_gear_result = 2;
     */
    equippedGearResult?: BulkComboResult;
    /**
     * @generated from protobuf field: string error_result = 3;
     */
    errorResult: string; // only set if sim failed.}
/**
 * @generated from protobuf message proto.BulkComboResult
 */
export interface BulkComboResult {
    /**
     * @generated from protobuf field: repeated proto.ItemSpecWithSlot items_added = 1;
     */
    itemsAdded: ItemSpecWithSlot[];
    /**
     * @generated from protobuf field: proto.UnitMetrics unit_metrics = 2;
     */
    unitMetrics?: UnitMetrics;
}
/**
 * @generated from protobuf message proto.ItemSpecWithSlot
 */
export interface ItemSpecWithSlot {
    /**
     * @generated from protobuf field: proto.ItemSpec item = 1;
     */
    item?: ItemSpec;
    /**
     * @generated from protobuf field: proto.ItemSlot slot = 2;
     */
    slot: ItemSlot;
}
/**
 * @generated from protobuf enum proto.ResourceType
 */
export enum ResourceType {
    /**
     * @generated from protobuf enum value: ResourceTypeNone = 0;
     */
    ResourceTypeNone = 0,
    /**
     * @generated from protobuf enum value: ResourceTypeMana = 1;
     */
    ResourceTypeMana = 1,
    /**
     * @generated from protobuf enum value: ResourceTypeEnergy = 2;
     */
    ResourceTypeEnergy = 2,
    /**
     * @generated from protobuf enum value: ResourceTypeRage = 3;
     */
    ResourceTypeRage = 3,
    /**
     * @generated from protobuf enum value: ResourceTypeComboPoints = 4;
     */
    ResourceTypeComboPoints = 4,
    /**
     * @generated from protobuf enum value: ResourceTypeFocus = 5;
     */
    ResourceTypeFocus = 5,
    /**
     * @generated from protobuf enum value: ResourceTypeHealth = 6;
     */
    ResourceTypeHealth = 6,
    /**
     * @generated from protobuf enum value: ResourceTypeRunicPower = 7;
     */
    ResourceTypeRunicPower = 7,
    /**
     * @generated from protobuf enum value: ResourceTypeBloodRune = 8;
     */
    ResourceTypeBloodRune = 8,
    /**
     * @generated from protobuf enum value: ResourceTypeFrostRune = 9;
     */
    ResourceTypeFrostRune = 9,
    /**
     * @generated from protobuf enum value: ResourceTypeUnholyRune = 10;
     */
    ResourceTypeUnholyRune = 10,
    /**
     * @generated from protobuf enum value: ResourceTypeDeathRune = 11;
     */
    ResourceTypeDeathRune = 11
}
// @generated message type with reflection information, may provide speed optimized methods
class Player$Type extends MessageType<Player> {
    constructor() {
        super("proto.Player", [
            { no: 16, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 1, name: "race", kind: "enum", T: () => ["proto.Race", Race] },
            { no: 2, name: "class", kind: "enum", T: () => ["proto.Class", Class] },
            { no: 24, name: "shatt_faction", kind: "enum", T: () => ["proto.ShattrathFaction", ShattrathFaction] },
            { no: 3, name: "equipment", kind: "message", T: () => EquipmentSpec },
            { no: 4, name: "consumes", kind: "message", T: () => Consumes },
            { no: 36, name: "bonus_stats", kind: "message", T: () => UnitStats },
            { no: 15, name: "buffs", kind: "message", T: () => IndividualBuffs },
            { no: 6, name: "balance_druid", kind: "message", oneof: "spec", T: () => BalanceDruid },
            { no: 22, name: "feral_druid", kind: "message", oneof: "spec", T: () => FeralDruid },
            { no: 26, name: "feral_tank_druid", kind: "message", oneof: "spec", T: () => FeralTankDruid },
            { no: 37, name: "restoration_druid", kind: "message", oneof: "spec", T: () => RestorationDruid },
            { no: 7, name: "hunter", kind: "message", oneof: "spec", T: () => Hunter },
            { no: 8, name: "mage", kind: "message", oneof: "spec", T: () => Mage },
            { no: 9, name: "retribution_paladin", kind: "message", oneof: "spec", T: () => RetributionPaladin },
            { no: 25, name: "protection_paladin", kind: "message", oneof: "spec", T: () => ProtectionPaladin },
            { no: 38, name: "holy_paladin", kind: "message", oneof: "spec", T: () => HolyPaladin },
            { no: 34, name: "healing_priest", kind: "message", oneof: "spec", T: () => HealingPriest },
            { no: 10, name: "shadow_priest", kind: "message", oneof: "spec", T: () => ShadowPriest },
            { no: 20, name: "smite_priest", kind: "message", oneof: "spec", T: () => SmitePriest },
            { no: 11, name: "rogue", kind: "message", oneof: "spec", T: () => Rogue },
            { no: 12, name: "elemental_shaman", kind: "message", oneof: "spec", T: () => ElementalShaman },
            { no: 18, name: "enhancement_shaman", kind: "message", oneof: "spec", T: () => EnhancementShaman },
            { no: 39, name: "restoration_shaman", kind: "message", oneof: "spec", T: () => RestorationShaman },
            { no: 13, name: "warlock", kind: "message", oneof: "spec", T: () => Warlock },
            { no: 14, name: "warrior", kind: "message", oneof: "spec", T: () => Warrior },
            { no: 21, name: "protection_warrior", kind: "message", oneof: "spec", T: () => ProtectionWarrior },
            { no: 31, name: "deathknight", kind: "message", oneof: "spec", T: () => Deathknight },
            { no: 32, name: "tank_deathknight", kind: "message", oneof: "spec", T: () => TankDeathknight },
            { no: 17, name: "talents_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 28, name: "glyphs", kind: "message", T: () => Glyphs },
            { no: 29, name: "profession1", kind: "enum", T: () => ["proto.Profession", Profession] },
            { no: 30, name: "profession2", kind: "enum", T: () => ["proto.Profession", Profession] },
            { no: 19, name: "cooldowns", kind: "message", T: () => Cooldowns },
            { no: 40, name: "rotation", kind: "message", T: () => APLRotation },
            { no: 41, name: "reaction_time_ms", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 42, name: "channel_clip_delay_ms", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 23, name: "in_front_of_target", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 33, name: "distance_from_target", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 27, name: "healing_model", kind: "message", T: () => HealingModel },
            { no: 35, name: "database", kind: "message", T: () => SimDatabase }
        ]);
    }
    create(value?: PartialMessage<Player>): Player {
        const message = { name: "", race: 0, class: 0, shattFaction: 0, spec: { oneofKind: undefined }, talentsString: "", profession1: 0, profession2: 0, reactionTimeMs: 0, channelClipDelayMs: 0, inFrontOfTarget: false, distanceFromTarget: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Player>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Player): Player {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 16:
                    message.name = reader.string();
                    break;
                case /* proto.Race race */ 1:
                    message.race = reader.int32();
                    break;
                case /* proto.Class class */ 2:
                    message.class = reader.int32();
                    break;
                case /* proto.ShattrathFaction shatt_faction */ 24:
                    message.shattFaction = reader.int32();
                    break;
                case /* proto.EquipmentSpec equipment */ 3:
                    message.equipment = EquipmentSpec.internalBinaryRead(reader, reader.uint32(), options, message.equipment);
                    break;
                case /* proto.Consumes consumes */ 4:
                    message.consumes = Consumes.internalBinaryRead(reader, reader.uint32(), options, message.consumes);
                    break;
                case /* proto.UnitStats bonus_stats */ 36:
                    message.bonusStats = UnitStats.internalBinaryRead(reader, reader.uint32(), options, message.bonusStats);
                    break;
                case /* proto.IndividualBuffs buffs */ 15:
                    message.buffs = IndividualBuffs.internalBinaryRead(reader, reader.uint32(), options, message.buffs);
                    break;
                case /* proto.BalanceDruid balance_druid */ 6:
                    message.spec = {
                        oneofKind: "balanceDruid",
                        balanceDruid: BalanceDruid.internalBinaryRead(reader, reader.uint32(), options, (message.spec as any).balanceDruid)
                    };
                    break;
                case /* proto.FeralDruid feral_druid */ 22:
                    message.spec = {
                        oneofKind: "feralDruid",
                        feralDruid: FeralDruid.internalBinaryRead(reader, reader.uint32(), options, (message.spec as any).feralDruid)
                    };
                    break;
                case /* proto.FeralTankDruid feral_tank_druid */ 26:
                    message.spec = {
                        oneofKind: "feralTankDruid",
                        feralTankDruid: FeralTankDruid.internalBinaryRead(reader, reader.uint32(), options, (message.spec as any).feralTankDruid)
                    };
                    break;
                case /* proto.RestorationDruid restoration_druid */ 37:
                    message.spec = {
                        oneofKind: "restorationDruid",
                        restorationDruid: RestorationDruid.internalBinaryRead(reader, reader.uint32(), options, (message.spec as any).restorationDruid)
                    };
                    break;
                case /* proto.Hunter hunter */ 7:
                    message.spec = {
                        oneofKind: "hunter",
                        hunter: Hunter.internalBinaryRead(reader, reader.uint32(), options, (message.spec as any).hunter)
                    };
                    break;
                case /* proto.Mage mage */ 8:
                    message.spec = {
                        oneofKind: "mage",
                        mage: Mage.internalBinaryRead(reader, reader.uint32(), options, (message.spec as any).mage)
                    };
                    break;
                case /* proto.RetributionPaladin retribution_paladin */ 9:
                    message.spec = {
                        oneofKind: "retributionPaladin",
                        retributionPaladin: RetributionPaladin.internalBinaryRead(reader, reader.uint32(), options, (message.spec as any).retributionPaladin)
                    };
                    break;
                case /* proto.ProtectionPaladin protection_paladin */ 25:
                    message.spec = {
                        oneofKind: "protectionPaladin",
                        protectionPaladin: ProtectionPaladin.internalBinaryRead(reader, reader.uint32(), options, (message.spec as any).protectionPaladin)
                    };
                    break;
                case /* proto.HolyPaladin holy_paladin */ 38:
                    message.spec = {
                        oneofKind: "holyPaladin",
                        holyPaladin: HolyPaladin.internalBinaryRead(reader, reader.uint32(), options, (message.spec as any).holyPaladin)
                    };
                    break;
                case /* proto.HealingPriest healing_priest */ 34:
                    message.spec = {
                        oneofKind: "healingPriest",
                        healingPriest: HealingPriest.internalBinaryRead(reader, reader.uint32(), options, (message.spec as any).healingPriest)
                    };
                    break;
                case /* proto.ShadowPriest shadow_priest */ 10:
                    message.spec = {
                        oneofKind: "shadowPriest",
                        shadowPriest: ShadowPriest.internalBinaryRead(reader, reader.uint32(), options, (message.spec as any).shadowPriest)
                    };
                    break;
                case /* proto.SmitePriest smite_priest */ 20:
                    message.spec = {
                        oneofKind: "smitePriest",
                        smitePriest: SmitePriest.internalBinaryRead(reader, reader.uint32(), options, (message.spec as any).smitePriest)
                    };
                    break;
                case /* proto.Rogue rogue */ 11:
                    message.spec = {
                        oneofKind: "rogue",
                        rogue: Rogue.internalBinaryRead(reader, reader.uint32(), options, (message.spec as any).rogue)
                    };
                    break;
                case /* proto.ElementalShaman elemental_shaman */ 12:
                    message.spec = {
                        oneofKind: "elementalShaman",
                        elementalShaman: ElementalShaman.internalBinaryRead(reader, reader.uint32(), options, (message.spec as any).elementalShaman)
                    };
                    break;
                case /* proto.EnhancementShaman enhancement_shaman */ 18:
                    message.spec = {
                        oneofKind: "enhancementShaman",
                        enhancementShaman: EnhancementShaman.internalBinaryRead(reader, reader.uint32(), options, (message.spec as any).enhancementShaman)
                    };
                    break;
                case /* proto.RestorationShaman restoration_shaman */ 39:
                    message.spec = {
                        oneofKind: "restorationShaman",
                        restorationShaman: RestorationShaman.internalBinaryRead(reader, reader.uint32(), options, (message.spec as any).restorationShaman)
                    };
                    break;
                case /* proto.Warlock warlock */ 13:
                    message.spec = {
                        oneofKind: "warlock",
                        warlock: Warlock.internalBinaryRead(reader, reader.uint32(), options, (message.spec as any).warlock)
                    };
                    break;
                case /* proto.Warrior warrior */ 14:
                    message.spec = {
                        oneofKind: "warrior",
                        warrior: Warrior.internalBinaryRead(reader, reader.uint32(), options, (message.spec as any).warrior)
                    };
                    break;
                case /* proto.ProtectionWarrior protection_warrior */ 21:
                    message.spec = {
                        oneofKind: "protectionWarrior",
                        protectionWarrior: ProtectionWarrior.internalBinaryRead(reader, reader.uint32(), options, (message.spec as any).protectionWarrior)
                    };
                    break;
                case /* proto.Deathknight deathknight */ 31:
                    message.spec = {
                        oneofKind: "deathknight",
                        deathknight: Deathknight.internalBinaryRead(reader, reader.uint32(), options, (message.spec as any).deathknight)
                    };
                    break;
                case /* proto.TankDeathknight tank_deathknight */ 32:
                    message.spec = {
                        oneofKind: "tankDeathknight",
                        tankDeathknight: TankDeathknight.internalBinaryRead(reader, reader.uint32(), options, (message.spec as any).tankDeathknight)
                    };
                    break;
                case /* string talents_string */ 17:
                    message.talentsString = reader.string();
                    break;
                case /* proto.Glyphs glyphs */ 28:
                    message.glyphs = Glyphs.internalBinaryRead(reader, reader.uint32(), options, message.glyphs);
                    break;
                case /* proto.Profession profession1 */ 29:
                    message.profession1 = reader.int32();
                    break;
                case /* proto.Profession profession2 */ 30:
                    message.profession2 = reader.int32();
                    break;
                case /* proto.Cooldowns cooldowns */ 19:
                    message.cooldowns = Cooldowns.internalBinaryRead(reader, reader.uint32(), options, message.cooldowns);
                    break;
                case /* proto.APLRotation rotation */ 40:
                    message.rotation = APLRotation.internalBinaryRead(reader, reader.uint32(), options, message.rotation);
                    break;
                case /* int32 reaction_time_ms */ 41:
                    message.reactionTimeMs = reader.int32();
                    break;
                case /* int32 channel_clip_delay_ms */ 42:
                    message.channelClipDelayMs = reader.int32();
                    break;
                case /* bool in_front_of_target */ 23:
                    message.inFrontOfTarget = reader.bool();
                    break;
                case /* double distance_from_target */ 33:
                    message.distanceFromTarget = reader.double();
                    break;
                case /* proto.HealingModel healing_model */ 27:
                    message.healingModel = HealingModel.internalBinaryRead(reader, reader.uint32(), options, message.healingModel);
                    break;
                case /* proto.SimDatabase database */ 35:
                    message.database = SimDatabase.internalBinaryRead(reader, reader.uint32(), options, message.database);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Player, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 16; */
        if (message.name !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.name);
        /* proto.Race race = 1; */
        if (message.race !== 0)
            writer.tag(1, WireType.Varint).int32(message.race);
        /* proto.Class class = 2; */
        if (message.class !== 0)
            writer.tag(2, WireType.Varint).int32(message.class);
        /* proto.ShattrathFaction shatt_faction = 24; */
        if (message.shattFaction !== 0)
            writer.tag(24, WireType.Varint).int32(message.shattFaction);
        /* proto.EquipmentSpec equipment = 3; */
        if (message.equipment)
            EquipmentSpec.internalBinaryWrite(message.equipment, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* proto.Consumes consumes = 4; */
        if (message.consumes)
            Consumes.internalBinaryWrite(message.consumes, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* proto.UnitStats bonus_stats = 36; */
        if (message.bonusStats)
            UnitStats.internalBinaryWrite(message.bonusStats, writer.tag(36, WireType.LengthDelimited).fork(), options).join();
        /* proto.IndividualBuffs buffs = 15; */
        if (message.buffs)
            IndividualBuffs.internalBinaryWrite(message.buffs, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* proto.BalanceDruid balance_druid = 6; */
        if (message.spec.oneofKind === "balanceDruid")
            BalanceDruid.internalBinaryWrite(message.spec.balanceDruid, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* proto.FeralDruid feral_druid = 22; */
        if (message.spec.oneofKind === "feralDruid")
            FeralDruid.internalBinaryWrite(message.spec.feralDruid, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* proto.FeralTankDruid feral_tank_druid = 26; */
        if (message.spec.oneofKind === "feralTankDruid")
            FeralTankDruid.internalBinaryWrite(message.spec.feralTankDruid, writer.tag(26, WireType.LengthDelimited).fork(), options).join();
        /* proto.RestorationDruid restoration_druid = 37; */
        if (message.spec.oneofKind === "restorationDruid")
            RestorationDruid.internalBinaryWrite(message.spec.restorationDruid, writer.tag(37, WireType.LengthDelimited).fork(), options).join();
        /* proto.Hunter hunter = 7; */
        if (message.spec.oneofKind === "hunter")
            Hunter.internalBinaryWrite(message.spec.hunter, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* proto.Mage mage = 8; */
        if (message.spec.oneofKind === "mage")
            Mage.internalBinaryWrite(message.spec.mage, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* proto.RetributionPaladin retribution_paladin = 9; */
        if (message.spec.oneofKind === "retributionPaladin")
            RetributionPaladin.internalBinaryWrite(message.spec.retributionPaladin, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* proto.ProtectionPaladin protection_paladin = 25; */
        if (message.spec.oneofKind === "protectionPaladin")
            ProtectionPaladin.internalBinaryWrite(message.spec.protectionPaladin, writer.tag(25, WireType.LengthDelimited).fork(), options).join();
        /* proto.HolyPaladin holy_paladin = 38; */
        if (message.spec.oneofKind === "holyPaladin")
            HolyPaladin.internalBinaryWrite(message.spec.holyPaladin, writer.tag(38, WireType.LengthDelimited).fork(), options).join();
        /* proto.HealingPriest healing_priest = 34; */
        if (message.spec.oneofKind === "healingPriest")
            HealingPriest.internalBinaryWrite(message.spec.healingPriest, writer.tag(34, WireType.LengthDelimited).fork(), options).join();
        /* proto.ShadowPriest shadow_priest = 10; */
        if (message.spec.oneofKind === "shadowPriest")
            ShadowPriest.internalBinaryWrite(message.spec.shadowPriest, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* proto.SmitePriest smite_priest = 20; */
        if (message.spec.oneofKind === "smitePriest")
            SmitePriest.internalBinaryWrite(message.spec.smitePriest, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* proto.Rogue rogue = 11; */
        if (message.spec.oneofKind === "rogue")
            Rogue.internalBinaryWrite(message.spec.rogue, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* proto.ElementalShaman elemental_shaman = 12; */
        if (message.spec.oneofKind === "elementalShaman")
            ElementalShaman.internalBinaryWrite(message.spec.elementalShaman, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* proto.EnhancementShaman enhancement_shaman = 18; */
        if (message.spec.oneofKind === "enhancementShaman")
            EnhancementShaman.internalBinaryWrite(message.spec.enhancementShaman, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* proto.RestorationShaman restoration_shaman = 39; */
        if (message.spec.oneofKind === "restorationShaman")
            RestorationShaman.internalBinaryWrite(message.spec.restorationShaman, writer.tag(39, WireType.LengthDelimited).fork(), options).join();
        /* proto.Warlock warlock = 13; */
        if (message.spec.oneofKind === "warlock")
            Warlock.internalBinaryWrite(message.spec.warlock, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* proto.Warrior warrior = 14; */
        if (message.spec.oneofKind === "warrior")
            Warrior.internalBinaryWrite(message.spec.warrior, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* proto.ProtectionWarrior protection_warrior = 21; */
        if (message.spec.oneofKind === "protectionWarrior")
            ProtectionWarrior.internalBinaryWrite(message.spec.protectionWarrior, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* proto.Deathknight deathknight = 31; */
        if (message.spec.oneofKind === "deathknight")
            Deathknight.internalBinaryWrite(message.spec.deathknight, writer.tag(31, WireType.LengthDelimited).fork(), options).join();
        /* proto.TankDeathknight tank_deathknight = 32; */
        if (message.spec.oneofKind === "tankDeathknight")
            TankDeathknight.internalBinaryWrite(message.spec.tankDeathknight, writer.tag(32, WireType.LengthDelimited).fork(), options).join();
        /* string talents_string = 17; */
        if (message.talentsString !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.talentsString);
        /* proto.Glyphs glyphs = 28; */
        if (message.glyphs)
            Glyphs.internalBinaryWrite(message.glyphs, writer.tag(28, WireType.LengthDelimited).fork(), options).join();
        /* proto.Profession profession1 = 29; */
        if (message.profession1 !== 0)
            writer.tag(29, WireType.Varint).int32(message.profession1);
        /* proto.Profession profession2 = 30; */
        if (message.profession2 !== 0)
            writer.tag(30, WireType.Varint).int32(message.profession2);
        /* proto.Cooldowns cooldowns = 19; */
        if (message.cooldowns)
            Cooldowns.internalBinaryWrite(message.cooldowns, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLRotation rotation = 40; */
        if (message.rotation)
            APLRotation.internalBinaryWrite(message.rotation, writer.tag(40, WireType.LengthDelimited).fork(), options).join();
        /* int32 reaction_time_ms = 41; */
        if (message.reactionTimeMs !== 0)
            writer.tag(41, WireType.Varint).int32(message.reactionTimeMs);
        /* int32 channel_clip_delay_ms = 42; */
        if (message.channelClipDelayMs !== 0)
            writer.tag(42, WireType.Varint).int32(message.channelClipDelayMs);
        /* bool in_front_of_target = 23; */
        if (message.inFrontOfTarget !== false)
            writer.tag(23, WireType.Varint).bool(message.inFrontOfTarget);
        /* double distance_from_target = 33; */
        if (message.distanceFromTarget !== 0)
            writer.tag(33, WireType.Bit64).double(message.distanceFromTarget);
        /* proto.HealingModel healing_model = 27; */
        if (message.healingModel)
            HealingModel.internalBinaryWrite(message.healingModel, writer.tag(27, WireType.LengthDelimited).fork(), options).join();
        /* proto.SimDatabase database = 35; */
        if (message.database)
            SimDatabase.internalBinaryWrite(message.database, writer.tag(35, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.Player
 */
export const Player = new Player$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Party$Type extends MessageType<Party> {
    constructor() {
        super("proto.Party", [
            { no: 1, name: "players", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Player },
            { no: 2, name: "buffs", kind: "message", T: () => PartyBuffs }
        ]);
    }
    create(value?: PartialMessage<Party>): Party {
        const message = { players: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Party>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Party): Party {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated proto.Player players */ 1:
                    message.players.push(Player.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* proto.PartyBuffs buffs */ 2:
                    message.buffs = PartyBuffs.internalBinaryRead(reader, reader.uint32(), options, message.buffs);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Party, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated proto.Player players = 1; */
        for (let i = 0; i < message.players.length; i++)
            Player.internalBinaryWrite(message.players[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.PartyBuffs buffs = 2; */
        if (message.buffs)
            PartyBuffs.internalBinaryWrite(message.buffs, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.Party
 */
export const Party = new Party$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Raid$Type extends MessageType<Raid> {
    constructor() {
        super("proto.Raid", [
            { no: 1, name: "parties", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Party },
            { no: 2, name: "num_active_parties", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "buffs", kind: "message", T: () => RaidBuffs },
            { no: 5, name: "debuffs", kind: "message", T: () => Debuffs },
            { no: 4, name: "tanks", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => UnitReference },
            { no: 3, name: "stagger_stormstrikes", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "target_dummies", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<Raid>): Raid {
        const message = { parties: [], numActiveParties: 0, tanks: [], staggerStormstrikes: false, targetDummies: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Raid>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Raid): Raid {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated proto.Party parties */ 1:
                    message.parties.push(Party.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 num_active_parties */ 2:
                    message.numActiveParties = reader.int32();
                    break;
                case /* proto.RaidBuffs buffs */ 7:
                    message.buffs = RaidBuffs.internalBinaryRead(reader, reader.uint32(), options, message.buffs);
                    break;
                case /* proto.Debuffs debuffs */ 5:
                    message.debuffs = Debuffs.internalBinaryRead(reader, reader.uint32(), options, message.debuffs);
                    break;
                case /* repeated proto.UnitReference tanks */ 4:
                    message.tanks.push(UnitReference.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool stagger_stormstrikes */ 3:
                    message.staggerStormstrikes = reader.bool();
                    break;
                case /* int32 target_dummies */ 6:
                    message.targetDummies = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Raid, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated proto.Party parties = 1; */
        for (let i = 0; i < message.parties.length; i++)
            Party.internalBinaryWrite(message.parties[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 num_active_parties = 2; */
        if (message.numActiveParties !== 0)
            writer.tag(2, WireType.Varint).int32(message.numActiveParties);
        /* proto.RaidBuffs buffs = 7; */
        if (message.buffs)
            RaidBuffs.internalBinaryWrite(message.buffs, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* proto.Debuffs debuffs = 5; */
        if (message.debuffs)
            Debuffs.internalBinaryWrite(message.debuffs, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated proto.UnitReference tanks = 4; */
        for (let i = 0; i < message.tanks.length; i++)
            UnitReference.internalBinaryWrite(message.tanks[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* bool stagger_stormstrikes = 3; */
        if (message.staggerStormstrikes !== false)
            writer.tag(3, WireType.Varint).bool(message.staggerStormstrikes);
        /* int32 target_dummies = 6; */
        if (message.targetDummies !== 0)
            writer.tag(6, WireType.Varint).int32(message.targetDummies);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.Raid
 */
export const Raid = new Raid$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SimOptions$Type extends MessageType<SimOptions> {
    constructor() {
        super("proto.SimOptions", [
            { no: 1, name: "iterations", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "random_seed", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "debug", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "debug_first_iteration", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "is_test", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "save_all_values", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "interactive", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<SimOptions>): SimOptions {
        const message = { iterations: 0, randomSeed: 0n, debug: false, debugFirstIteration: false, isTest: false, saveAllValues: false, interactive: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SimOptions>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SimOptions): SimOptions {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 iterations */ 1:
                    message.iterations = reader.int32();
                    break;
                case /* int64 random_seed */ 2:
                    message.randomSeed = reader.int64().toBigInt();
                    break;
                case /* bool debug */ 3:
                    message.debug = reader.bool();
                    break;
                case /* bool debug_first_iteration */ 6:
                    message.debugFirstIteration = reader.bool();
                    break;
                case /* bool is_test */ 5:
                    message.isTest = reader.bool();
                    break;
                case /* bool save_all_values */ 7:
                    message.saveAllValues = reader.bool();
                    break;
                case /* bool interactive */ 8:
                    message.interactive = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SimOptions, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 iterations = 1; */
        if (message.iterations !== 0)
            writer.tag(1, WireType.Varint).int32(message.iterations);
        /* int64 random_seed = 2; */
        if (message.randomSeed !== 0n)
            writer.tag(2, WireType.Varint).int64(message.randomSeed);
        /* bool debug = 3; */
        if (message.debug !== false)
            writer.tag(3, WireType.Varint).bool(message.debug);
        /* bool debug_first_iteration = 6; */
        if (message.debugFirstIteration !== false)
            writer.tag(6, WireType.Varint).bool(message.debugFirstIteration);
        /* bool is_test = 5; */
        if (message.isTest !== false)
            writer.tag(5, WireType.Varint).bool(message.isTest);
        /* bool save_all_values = 7; */
        if (message.saveAllValues !== false)
            writer.tag(7, WireType.Varint).bool(message.saveAllValues);
        /* bool interactive = 8; */
        if (message.interactive !== false)
            writer.tag(8, WireType.Varint).bool(message.interactive);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.SimOptions
 */
export const SimOptions = new SimOptions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionMetrics$Type extends MessageType<ActionMetrics> {
    constructor() {
        super("proto.ActionMetrics", [
            { no: 1, name: "id", kind: "message", T: () => ActionID },
            { no: 2, name: "is_melee", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "targets", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => TargetedActionMetrics }
        ]);
    }
    create(value?: PartialMessage<ActionMetrics>): ActionMetrics {
        const message = { isMelee: false, targets: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ActionMetrics>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActionMetrics): ActionMetrics {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.ActionID id */ 1:
                    message.id = ActionID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* bool is_melee */ 2:
                    message.isMelee = reader.bool();
                    break;
                case /* repeated proto.TargetedActionMetrics targets */ 3:
                    message.targets.push(TargetedActionMetrics.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActionMetrics, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.ActionID id = 1; */
        if (message.id)
            ActionID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool is_melee = 2; */
        if (message.isMelee !== false)
            writer.tag(2, WireType.Varint).bool(message.isMelee);
        /* repeated proto.TargetedActionMetrics targets = 3; */
        for (let i = 0; i < message.targets.length; i++)
            TargetedActionMetrics.internalBinaryWrite(message.targets[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.ActionMetrics
 */
export const ActionMetrics = new ActionMetrics$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TargetedActionMetrics$Type extends MessageType<TargetedActionMetrics> {
    constructor() {
        super("proto.TargetedActionMetrics", [
            { no: 12, name: "unit_index", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 1, name: "casts", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "hits", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "crits", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "misses", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "dodges", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "parries", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "blocks", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "glances", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "damage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 10, name: "threat", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 11, name: "healing", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 13, name: "shielding", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 14, name: "cast_time_ms", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<TargetedActionMetrics>): TargetedActionMetrics {
        const message = { unitIndex: 0, casts: 0, hits: 0, crits: 0, misses: 0, dodges: 0, parries: 0, blocks: 0, glances: 0, damage: 0, threat: 0, healing: 0, shielding: 0, castTimeMs: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<TargetedActionMetrics>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TargetedActionMetrics): TargetedActionMetrics {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 unit_index */ 12:
                    message.unitIndex = reader.int32();
                    break;
                case /* int32 casts */ 1:
                    message.casts = reader.int32();
                    break;
                case /* int32 hits */ 2:
                    message.hits = reader.int32();
                    break;
                case /* int32 crits */ 3:
                    message.crits = reader.int32();
                    break;
                case /* int32 misses */ 4:
                    message.misses = reader.int32();
                    break;
                case /* int32 dodges */ 5:
                    message.dodges = reader.int32();
                    break;
                case /* int32 parries */ 6:
                    message.parries = reader.int32();
                    break;
                case /* int32 blocks */ 7:
                    message.blocks = reader.int32();
                    break;
                case /* int32 glances */ 8:
                    message.glances = reader.int32();
                    break;
                case /* double damage */ 9:
                    message.damage = reader.double();
                    break;
                case /* double threat */ 10:
                    message.threat = reader.double();
                    break;
                case /* double healing */ 11:
                    message.healing = reader.double();
                    break;
                case /* double shielding */ 13:
                    message.shielding = reader.double();
                    break;
                case /* double cast_time_ms */ 14:
                    message.castTimeMs = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TargetedActionMetrics, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 unit_index = 12; */
        if (message.unitIndex !== 0)
            writer.tag(12, WireType.Varint).int32(message.unitIndex);
        /* int32 casts = 1; */
        if (message.casts !== 0)
            writer.tag(1, WireType.Varint).int32(message.casts);
        /* int32 hits = 2; */
        if (message.hits !== 0)
            writer.tag(2, WireType.Varint).int32(message.hits);
        /* int32 crits = 3; */
        if (message.crits !== 0)
            writer.tag(3, WireType.Varint).int32(message.crits);
        /* int32 misses = 4; */
        if (message.misses !== 0)
            writer.tag(4, WireType.Varint).int32(message.misses);
        /* int32 dodges = 5; */
        if (message.dodges !== 0)
            writer.tag(5, WireType.Varint).int32(message.dodges);
        /* int32 parries = 6; */
        if (message.parries !== 0)
            writer.tag(6, WireType.Varint).int32(message.parries);
        /* int32 blocks = 7; */
        if (message.blocks !== 0)
            writer.tag(7, WireType.Varint).int32(message.blocks);
        /* int32 glances = 8; */
        if (message.glances !== 0)
            writer.tag(8, WireType.Varint).int32(message.glances);
        /* double damage = 9; */
        if (message.damage !== 0)
            writer.tag(9, WireType.Bit64).double(message.damage);
        /* double threat = 10; */
        if (message.threat !== 0)
            writer.tag(10, WireType.Bit64).double(message.threat);
        /* double healing = 11; */
        if (message.healing !== 0)
            writer.tag(11, WireType.Bit64).double(message.healing);
        /* double shielding = 13; */
        if (message.shielding !== 0)
            writer.tag(13, WireType.Bit64).double(message.shielding);
        /* double cast_time_ms = 14; */
        if (message.castTimeMs !== 0)
            writer.tag(14, WireType.Bit64).double(message.castTimeMs);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.TargetedActionMetrics
 */
export const TargetedActionMetrics = new TargetedActionMetrics$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuraMetrics$Type extends MessageType<AuraMetrics> {
    constructor() {
        super("proto.AuraMetrics", [
            { no: 1, name: "id", kind: "message", T: () => ActionID },
            { no: 2, name: "uptime_seconds_avg", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "uptime_seconds_stdev", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "procs_avg", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<AuraMetrics>): AuraMetrics {
        const message = { uptimeSecondsAvg: 0, uptimeSecondsStdev: 0, procsAvg: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AuraMetrics>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AuraMetrics): AuraMetrics {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.ActionID id */ 1:
                    message.id = ActionID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* double uptime_seconds_avg */ 2:
                    message.uptimeSecondsAvg = reader.double();
                    break;
                case /* double uptime_seconds_stdev */ 3:
                    message.uptimeSecondsStdev = reader.double();
                    break;
                case /* double procs_avg */ 4:
                    message.procsAvg = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AuraMetrics, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.ActionID id = 1; */
        if (message.id)
            ActionID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* double uptime_seconds_avg = 2; */
        if (message.uptimeSecondsAvg !== 0)
            writer.tag(2, WireType.Bit64).double(message.uptimeSecondsAvg);
        /* double uptime_seconds_stdev = 3; */
        if (message.uptimeSecondsStdev !== 0)
            writer.tag(3, WireType.Bit64).double(message.uptimeSecondsStdev);
        /* double procs_avg = 4; */
        if (message.procsAvg !== 0)
            writer.tag(4, WireType.Bit64).double(message.procsAvg);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.AuraMetrics
 */
export const AuraMetrics = new AuraMetrics$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResourceMetrics$Type extends MessageType<ResourceMetrics> {
    constructor() {
        super("proto.ResourceMetrics", [
            { no: 1, name: "id", kind: "message", T: () => ActionID },
            { no: 2, name: "type", kind: "enum", T: () => ["proto.ResourceType", ResourceType] },
            { no: 3, name: "events", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "gain", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "actual_gain", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<ResourceMetrics>): ResourceMetrics {
        const message = { type: 0, events: 0, gain: 0, actualGain: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ResourceMetrics>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResourceMetrics): ResourceMetrics {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.ActionID id */ 1:
                    message.id = ActionID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* proto.ResourceType type */ 2:
                    message.type = reader.int32();
                    break;
                case /* int32 events */ 3:
                    message.events = reader.int32();
                    break;
                case /* double gain */ 4:
                    message.gain = reader.double();
                    break;
                case /* double actual_gain */ 5:
                    message.actualGain = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResourceMetrics, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.ActionID id = 1; */
        if (message.id)
            ActionID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.ResourceType type = 2; */
        if (message.type !== 0)
            writer.tag(2, WireType.Varint).int32(message.type);
        /* int32 events = 3; */
        if (message.events !== 0)
            writer.tag(3, WireType.Varint).int32(message.events);
        /* double gain = 4; */
        if (message.gain !== 0)
            writer.tag(4, WireType.Bit64).double(message.gain);
        /* double actual_gain = 5; */
        if (message.actualGain !== 0)
            writer.tag(5, WireType.Bit64).double(message.actualGain);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.ResourceMetrics
 */
export const ResourceMetrics = new ResourceMetrics$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DistributionMetrics$Type extends MessageType<DistributionMetrics> {
    constructor() {
        super("proto.DistributionMetrics", [
            { no: 1, name: "avg", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "stdev", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "max", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "max_seed", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 6, name: "min", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "min_seed", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "hist", kind: "map", K: 5 /*ScalarType.INT32*/, V: { kind: "scalar", T: 5 /*ScalarType.INT32*/ } },
            { no: 8, name: "all_values", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<DistributionMetrics>): DistributionMetrics {
        const message = { avg: 0, stdev: 0, max: 0, maxSeed: 0n, min: 0, minSeed: 0n, hist: {}, allValues: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DistributionMetrics>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DistributionMetrics): DistributionMetrics {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double avg */ 1:
                    message.avg = reader.double();
                    break;
                case /* double stdev */ 2:
                    message.stdev = reader.double();
                    break;
                case /* double max */ 3:
                    message.max = reader.double();
                    break;
                case /* int64 max_seed */ 5:
                    message.maxSeed = reader.int64().toBigInt();
                    break;
                case /* double min */ 6:
                    message.min = reader.double();
                    break;
                case /* int64 min_seed */ 7:
                    message.minSeed = reader.int64().toBigInt();
                    break;
                case /* map<int32, int32> hist */ 4:
                    this.binaryReadMap4(message.hist, reader, options);
                    break;
                case /* repeated double all_values */ 8:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.allValues.push(reader.double());
                    else
                        message.allValues.push(reader.double());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap4(map: DistributionMetrics["hist"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof DistributionMetrics["hist"] | undefined, val: DistributionMetrics["hist"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.int32();
                    break;
                case 2:
                    val = reader.int32();
                    break;
                default: throw new globalThis.Error("unknown map entry field for field proto.DistributionMetrics.hist");
            }
        }
        map[key ?? 0] = val ?? 0;
    }
    internalBinaryWrite(message: DistributionMetrics, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* double avg = 1; */
        if (message.avg !== 0)
            writer.tag(1, WireType.Bit64).double(message.avg);
        /* double stdev = 2; */
        if (message.stdev !== 0)
            writer.tag(2, WireType.Bit64).double(message.stdev);
        /* double max = 3; */
        if (message.max !== 0)
            writer.tag(3, WireType.Bit64).double(message.max);
        /* int64 max_seed = 5; */
        if (message.maxSeed !== 0n)
            writer.tag(5, WireType.Varint).int64(message.maxSeed);
        /* double min = 6; */
        if (message.min !== 0)
            writer.tag(6, WireType.Bit64).double(message.min);
        /* int64 min_seed = 7; */
        if (message.minSeed !== 0n)
            writer.tag(7, WireType.Varint).int64(message.minSeed);
        /* map<int32, int32> hist = 4; */
        for (let k of Object.keys(message.hist))
            writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.Varint).int32(parseInt(k)).tag(2, WireType.Varint).int32(message.hist[k as any]).join();
        /* repeated double all_values = 8; */
        if (message.allValues.length) {
            writer.tag(8, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.allValues.length; i++)
                writer.double(message.allValues[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.DistributionMetrics
 */
export const DistributionMetrics = new DistributionMetrics$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnitMetrics$Type extends MessageType<UnitMetrics> {
    constructor() {
        super("proto.UnitMetrics", [
            { no: 9, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "unit_index", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 1, name: "dps", kind: "message", T: () => DistributionMetrics },
            { no: 16, name: "dpasp", kind: "message", T: () => DistributionMetrics },
            { no: 8, name: "threat", kind: "message", T: () => DistributionMetrics },
            { no: 11, name: "dtps", kind: "message", T: () => DistributionMetrics },
            { no: 17, name: "tmi", kind: "message", T: () => DistributionMetrics },
            { no: 14, name: "hps", kind: "message", T: () => DistributionMetrics },
            { no: 15, name: "tto", kind: "message", T: () => DistributionMetrics },
            { no: 3, name: "seconds_oom_avg", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 12, name: "chance_of_death", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "actions", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ActionMetrics },
            { no: 6, name: "auras", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => AuraMetrics },
            { no: 10, name: "resources", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ResourceMetrics },
            { no: 7, name: "pets", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => UnitMetrics }
        ]);
    }
    create(value?: PartialMessage<UnitMetrics>): UnitMetrics {
        const message = { name: "", unitIndex: 0, secondsOomAvg: 0, chanceOfDeath: 0, actions: [], auras: [], resources: [], pets: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<UnitMetrics>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UnitMetrics): UnitMetrics {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 9:
                    message.name = reader.string();
                    break;
                case /* int32 unit_index */ 13:
                    message.unitIndex = reader.int32();
                    break;
                case /* proto.DistributionMetrics dps */ 1:
                    message.dps = DistributionMetrics.internalBinaryRead(reader, reader.uint32(), options, message.dps);
                    break;
                case /* proto.DistributionMetrics dpasp */ 16:
                    message.dpasp = DistributionMetrics.internalBinaryRead(reader, reader.uint32(), options, message.dpasp);
                    break;
                case /* proto.DistributionMetrics threat */ 8:
                    message.threat = DistributionMetrics.internalBinaryRead(reader, reader.uint32(), options, message.threat);
                    break;
                case /* proto.DistributionMetrics dtps */ 11:
                    message.dtps = DistributionMetrics.internalBinaryRead(reader, reader.uint32(), options, message.dtps);
                    break;
                case /* proto.DistributionMetrics tmi */ 17:
                    message.tmi = DistributionMetrics.internalBinaryRead(reader, reader.uint32(), options, message.tmi);
                    break;
                case /* proto.DistributionMetrics hps */ 14:
                    message.hps = DistributionMetrics.internalBinaryRead(reader, reader.uint32(), options, message.hps);
                    break;
                case /* proto.DistributionMetrics tto */ 15:
                    message.tto = DistributionMetrics.internalBinaryRead(reader, reader.uint32(), options, message.tto);
                    break;
                case /* double seconds_oom_avg */ 3:
                    message.secondsOomAvg = reader.double();
                    break;
                case /* double chance_of_death */ 12:
                    message.chanceOfDeath = reader.double();
                    break;
                case /* repeated proto.ActionMetrics actions */ 5:
                    message.actions.push(ActionMetrics.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated proto.AuraMetrics auras */ 6:
                    message.auras.push(AuraMetrics.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated proto.ResourceMetrics resources */ 10:
                    message.resources.push(ResourceMetrics.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated proto.UnitMetrics pets */ 7:
                    message.pets.push(UnitMetrics.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UnitMetrics, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 9; */
        if (message.name !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.name);
        /* int32 unit_index = 13; */
        if (message.unitIndex !== 0)
            writer.tag(13, WireType.Varint).int32(message.unitIndex);
        /* proto.DistributionMetrics dps = 1; */
        if (message.dps)
            DistributionMetrics.internalBinaryWrite(message.dps, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.DistributionMetrics dpasp = 16; */
        if (message.dpasp)
            DistributionMetrics.internalBinaryWrite(message.dpasp, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* proto.DistributionMetrics threat = 8; */
        if (message.threat)
            DistributionMetrics.internalBinaryWrite(message.threat, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* proto.DistributionMetrics dtps = 11; */
        if (message.dtps)
            DistributionMetrics.internalBinaryWrite(message.dtps, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* proto.DistributionMetrics tmi = 17; */
        if (message.tmi)
            DistributionMetrics.internalBinaryWrite(message.tmi, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* proto.DistributionMetrics hps = 14; */
        if (message.hps)
            DistributionMetrics.internalBinaryWrite(message.hps, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* proto.DistributionMetrics tto = 15; */
        if (message.tto)
            DistributionMetrics.internalBinaryWrite(message.tto, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* double seconds_oom_avg = 3; */
        if (message.secondsOomAvg !== 0)
            writer.tag(3, WireType.Bit64).double(message.secondsOomAvg);
        /* double chance_of_death = 12; */
        if (message.chanceOfDeath !== 0)
            writer.tag(12, WireType.Bit64).double(message.chanceOfDeath);
        /* repeated proto.ActionMetrics actions = 5; */
        for (let i = 0; i < message.actions.length; i++)
            ActionMetrics.internalBinaryWrite(message.actions[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated proto.AuraMetrics auras = 6; */
        for (let i = 0; i < message.auras.length; i++)
            AuraMetrics.internalBinaryWrite(message.auras[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated proto.ResourceMetrics resources = 10; */
        for (let i = 0; i < message.resources.length; i++)
            ResourceMetrics.internalBinaryWrite(message.resources[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* repeated proto.UnitMetrics pets = 7; */
        for (let i = 0; i < message.pets.length; i++)
            UnitMetrics.internalBinaryWrite(message.pets[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.UnitMetrics
 */
export const UnitMetrics = new UnitMetrics$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PartyMetrics$Type extends MessageType<PartyMetrics> {
    constructor() {
        super("proto.PartyMetrics", [
            { no: 1, name: "dps", kind: "message", T: () => DistributionMetrics },
            { no: 3, name: "hps", kind: "message", T: () => DistributionMetrics },
            { no: 2, name: "players", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => UnitMetrics }
        ]);
    }
    create(value?: PartialMessage<PartyMetrics>): PartyMetrics {
        const message = { players: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<PartyMetrics>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PartyMetrics): PartyMetrics {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.DistributionMetrics dps */ 1:
                    message.dps = DistributionMetrics.internalBinaryRead(reader, reader.uint32(), options, message.dps);
                    break;
                case /* proto.DistributionMetrics hps */ 3:
                    message.hps = DistributionMetrics.internalBinaryRead(reader, reader.uint32(), options, message.hps);
                    break;
                case /* repeated proto.UnitMetrics players */ 2:
                    message.players.push(UnitMetrics.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PartyMetrics, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.DistributionMetrics dps = 1; */
        if (message.dps)
            DistributionMetrics.internalBinaryWrite(message.dps, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.DistributionMetrics hps = 3; */
        if (message.hps)
            DistributionMetrics.internalBinaryWrite(message.hps, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated proto.UnitMetrics players = 2; */
        for (let i = 0; i < message.players.length; i++)
            UnitMetrics.internalBinaryWrite(message.players[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.PartyMetrics
 */
export const PartyMetrics = new PartyMetrics$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RaidMetrics$Type extends MessageType<RaidMetrics> {
    constructor() {
        super("proto.RaidMetrics", [
            { no: 1, name: "dps", kind: "message", T: () => DistributionMetrics },
            { no: 3, name: "hps", kind: "message", T: () => DistributionMetrics },
            { no: 2, name: "parties", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => PartyMetrics }
        ]);
    }
    create(value?: PartialMessage<RaidMetrics>): RaidMetrics {
        const message = { parties: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<RaidMetrics>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RaidMetrics): RaidMetrics {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.DistributionMetrics dps */ 1:
                    message.dps = DistributionMetrics.internalBinaryRead(reader, reader.uint32(), options, message.dps);
                    break;
                case /* proto.DistributionMetrics hps */ 3:
                    message.hps = DistributionMetrics.internalBinaryRead(reader, reader.uint32(), options, message.hps);
                    break;
                case /* repeated proto.PartyMetrics parties */ 2:
                    message.parties.push(PartyMetrics.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RaidMetrics, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.DistributionMetrics dps = 1; */
        if (message.dps)
            DistributionMetrics.internalBinaryWrite(message.dps, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.DistributionMetrics hps = 3; */
        if (message.hps)
            DistributionMetrics.internalBinaryWrite(message.hps, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated proto.PartyMetrics parties = 2; */
        for (let i = 0; i < message.parties.length; i++)
            PartyMetrics.internalBinaryWrite(message.parties[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.RaidMetrics
 */
export const RaidMetrics = new RaidMetrics$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EncounterMetrics$Type extends MessageType<EncounterMetrics> {
    constructor() {
        super("proto.EncounterMetrics", [
            { no: 1, name: "targets", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => UnitMetrics }
        ]);
    }
    create(value?: PartialMessage<EncounterMetrics>): EncounterMetrics {
        const message = { targets: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<EncounterMetrics>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EncounterMetrics): EncounterMetrics {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated proto.UnitMetrics targets */ 1:
                    message.targets.push(UnitMetrics.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EncounterMetrics, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated proto.UnitMetrics targets = 1; */
        for (let i = 0; i < message.targets.length; i++)
            UnitMetrics.internalBinaryWrite(message.targets[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.EncounterMetrics
 */
export const EncounterMetrics = new EncounterMetrics$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RaidSimRequest$Type extends MessageType<RaidSimRequest> {
    constructor() {
        super("proto.RaidSimRequest", [
            { no: 1, name: "raid", kind: "message", T: () => Raid },
            { no: 2, name: "encounter", kind: "message", T: () => Encounter },
            { no: 3, name: "sim_options", kind: "message", T: () => SimOptions }
        ]);
    }
    create(value?: PartialMessage<RaidSimRequest>): RaidSimRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<RaidSimRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RaidSimRequest): RaidSimRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.Raid raid */ 1:
                    message.raid = Raid.internalBinaryRead(reader, reader.uint32(), options, message.raid);
                    break;
                case /* proto.Encounter encounter */ 2:
                    message.encounter = Encounter.internalBinaryRead(reader, reader.uint32(), options, message.encounter);
                    break;
                case /* proto.SimOptions sim_options */ 3:
                    message.simOptions = SimOptions.internalBinaryRead(reader, reader.uint32(), options, message.simOptions);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RaidSimRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.Raid raid = 1; */
        if (message.raid)
            Raid.internalBinaryWrite(message.raid, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.Encounter encounter = 2; */
        if (message.encounter)
            Encounter.internalBinaryWrite(message.encounter, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* proto.SimOptions sim_options = 3; */
        if (message.simOptions)
            SimOptions.internalBinaryWrite(message.simOptions, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.RaidSimRequest
 */
export const RaidSimRequest = new RaidSimRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RaidSimResult$Type extends MessageType<RaidSimResult> {
    constructor() {
        super("proto.RaidSimResult", [
            { no: 1, name: "raid_metrics", kind: "message", T: () => RaidMetrics },
            { no: 2, name: "encounter_metrics", kind: "message", T: () => EncounterMetrics },
            { no: 3, name: "logs", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "first_iteration_duration", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "avg_iteration_duration", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "error_result", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RaidSimResult>): RaidSimResult {
        const message = { logs: "", firstIterationDuration: 0, avgIterationDuration: 0, errorResult: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<RaidSimResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RaidSimResult): RaidSimResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.RaidMetrics raid_metrics */ 1:
                    message.raidMetrics = RaidMetrics.internalBinaryRead(reader, reader.uint32(), options, message.raidMetrics);
                    break;
                case /* proto.EncounterMetrics encounter_metrics */ 2:
                    message.encounterMetrics = EncounterMetrics.internalBinaryRead(reader, reader.uint32(), options, message.encounterMetrics);
                    break;
                case /* string logs */ 3:
                    message.logs = reader.string();
                    break;
                case /* double first_iteration_duration */ 4:
                    message.firstIterationDuration = reader.double();
                    break;
                case /* double avg_iteration_duration */ 6:
                    message.avgIterationDuration = reader.double();
                    break;
                case /* string error_result */ 5:
                    message.errorResult = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RaidSimResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.RaidMetrics raid_metrics = 1; */
        if (message.raidMetrics)
            RaidMetrics.internalBinaryWrite(message.raidMetrics, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.EncounterMetrics encounter_metrics = 2; */
        if (message.encounterMetrics)
            EncounterMetrics.internalBinaryWrite(message.encounterMetrics, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string logs = 3; */
        if (message.logs !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.logs);
        /* double first_iteration_duration = 4; */
        if (message.firstIterationDuration !== 0)
            writer.tag(4, WireType.Bit64).double(message.firstIterationDuration);
        /* double avg_iteration_duration = 6; */
        if (message.avgIterationDuration !== 0)
            writer.tag(6, WireType.Bit64).double(message.avgIterationDuration);
        /* string error_result = 5; */
        if (message.errorResult !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.errorResult);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.RaidSimResult
 */
export const RaidSimResult = new RaidSimResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ComputeStatsRequest$Type extends MessageType<ComputeStatsRequest> {
    constructor() {
        super("proto.ComputeStatsRequest", [
            { no: 1, name: "raid", kind: "message", T: () => Raid },
            { no: 2, name: "encounter", kind: "message", T: () => Encounter }
        ]);
    }
    create(value?: PartialMessage<ComputeStatsRequest>): ComputeStatsRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ComputeStatsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ComputeStatsRequest): ComputeStatsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.Raid raid */ 1:
                    message.raid = Raid.internalBinaryRead(reader, reader.uint32(), options, message.raid);
                    break;
                case /* proto.Encounter encounter */ 2:
                    message.encounter = Encounter.internalBinaryRead(reader, reader.uint32(), options, message.encounter);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ComputeStatsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.Raid raid = 1; */
        if (message.raid)
            Raid.internalBinaryWrite(message.raid, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.Encounter encounter = 2; */
        if (message.encounter)
            Encounter.internalBinaryWrite(message.encounter, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.ComputeStatsRequest
 */
export const ComputeStatsRequest = new ComputeStatsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuraStats$Type extends MessageType<AuraStats> {
    constructor() {
        super("proto.AuraStats", [
            { no: 1, name: "id", kind: "message", T: () => ActionID },
            { no: 2, name: "max_stacks", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "has_icd", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "has_exclusive_effect", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AuraStats>): AuraStats {
        const message = { maxStacks: 0, hasIcd: false, hasExclusiveEffect: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AuraStats>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AuraStats): AuraStats {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.ActionID id */ 1:
                    message.id = ActionID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* int32 max_stacks */ 2:
                    message.maxStacks = reader.int32();
                    break;
                case /* bool has_icd */ 3:
                    message.hasIcd = reader.bool();
                    break;
                case /* bool has_exclusive_effect */ 4:
                    message.hasExclusiveEffect = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AuraStats, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.ActionID id = 1; */
        if (message.id)
            ActionID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 max_stacks = 2; */
        if (message.maxStacks !== 0)
            writer.tag(2, WireType.Varint).int32(message.maxStacks);
        /* bool has_icd = 3; */
        if (message.hasIcd !== false)
            writer.tag(3, WireType.Varint).bool(message.hasIcd);
        /* bool has_exclusive_effect = 4; */
        if (message.hasExclusiveEffect !== false)
            writer.tag(4, WireType.Varint).bool(message.hasExclusiveEffect);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.AuraStats
 */
export const AuraStats = new AuraStats$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SpellStats$Type extends MessageType<SpellStats> {
    constructor() {
        super("proto.SpellStats", [
            { no: 1, name: "id", kind: "message", T: () => ActionID },
            { no: 2, name: "is_castable", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "is_channeled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "is_major_cooldown", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "has_dot", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "has_shield", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "prepull_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<SpellStats>): SpellStats {
        const message = { isCastable: false, isChanneled: false, isMajorCooldown: false, hasDot: false, hasShield: false, prepullOnly: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SpellStats>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SpellStats): SpellStats {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.ActionID id */ 1:
                    message.id = ActionID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* bool is_castable */ 2:
                    message.isCastable = reader.bool();
                    break;
                case /* bool is_channeled */ 7:
                    message.isChanneled = reader.bool();
                    break;
                case /* bool is_major_cooldown */ 3:
                    message.isMajorCooldown = reader.bool();
                    break;
                case /* bool has_dot */ 4:
                    message.hasDot = reader.bool();
                    break;
                case /* bool has_shield */ 6:
                    message.hasShield = reader.bool();
                    break;
                case /* bool prepull_only */ 5:
                    message.prepullOnly = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SpellStats, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.ActionID id = 1; */
        if (message.id)
            ActionID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool is_castable = 2; */
        if (message.isCastable !== false)
            writer.tag(2, WireType.Varint).bool(message.isCastable);
        /* bool is_channeled = 7; */
        if (message.isChanneled !== false)
            writer.tag(7, WireType.Varint).bool(message.isChanneled);
        /* bool is_major_cooldown = 3; */
        if (message.isMajorCooldown !== false)
            writer.tag(3, WireType.Varint).bool(message.isMajorCooldown);
        /* bool has_dot = 4; */
        if (message.hasDot !== false)
            writer.tag(4, WireType.Varint).bool(message.hasDot);
        /* bool has_shield = 6; */
        if (message.hasShield !== false)
            writer.tag(6, WireType.Varint).bool(message.hasShield);
        /* bool prepull_only = 5; */
        if (message.prepullOnly !== false)
            writer.tag(5, WireType.Varint).bool(message.prepullOnly);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.SpellStats
 */
export const SpellStats = new SpellStats$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLActionStats$Type extends MessageType<APLActionStats> {
    constructor() {
        super("proto.APLActionStats", [
            { no: 1, name: "warnings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<APLActionStats>): APLActionStats {
        const message = { warnings: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLActionStats>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLActionStats): APLActionStats {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string warnings */ 1:
                    message.warnings.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLActionStats, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string warnings = 1; */
        for (let i = 0; i < message.warnings.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.warnings[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLActionStats
 */
export const APLActionStats = new APLActionStats$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APLStats$Type extends MessageType<APLStats> {
    constructor() {
        super("proto.APLStats", [
            { no: 1, name: "prepull_actions", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => APLActionStats },
            { no: 2, name: "priority_list", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => APLActionStats }
        ]);
    }
    create(value?: PartialMessage<APLStats>): APLStats {
        const message = { prepullActions: [], priorityList: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<APLStats>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: APLStats): APLStats {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated proto.APLActionStats prepull_actions */ 1:
                    message.prepullActions.push(APLActionStats.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated proto.APLActionStats priority_list */ 2:
                    message.priorityList.push(APLActionStats.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: APLStats, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated proto.APLActionStats prepull_actions = 1; */
        for (let i = 0; i < message.prepullActions.length; i++)
            APLActionStats.internalBinaryWrite(message.prepullActions[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated proto.APLActionStats priority_list = 2; */
        for (let i = 0; i < message.priorityList.length; i++)
            APLActionStats.internalBinaryWrite(message.priorityList[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.APLStats
 */
export const APLStats = new APLStats$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnitMetadata$Type extends MessageType<UnitMetadata> {
    constructor() {
        super("proto.UnitMetadata", [
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 1, name: "spells", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => SpellStats },
            { no: 2, name: "auras", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => AuraStats }
        ]);
    }
    create(value?: PartialMessage<UnitMetadata>): UnitMetadata {
        const message = { name: "", spells: [], auras: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<UnitMetadata>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UnitMetadata): UnitMetadata {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* repeated proto.SpellStats spells */ 1:
                    message.spells.push(SpellStats.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated proto.AuraStats auras */ 2:
                    message.auras.push(AuraStats.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UnitMetadata, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* repeated proto.SpellStats spells = 1; */
        for (let i = 0; i < message.spells.length; i++)
            SpellStats.internalBinaryWrite(message.spells[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated proto.AuraStats auras = 2; */
        for (let i = 0; i < message.auras.length; i++)
            AuraStats.internalBinaryWrite(message.auras[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.UnitMetadata
 */
export const UnitMetadata = new UnitMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PetStats$Type extends MessageType<PetStats> {
    constructor() {
        super("proto.PetStats", [
            { no: 1, name: "metadata", kind: "message", T: () => UnitMetadata }
        ]);
    }
    create(value?: PartialMessage<PetStats>): PetStats {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<PetStats>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PetStats): PetStats {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.UnitMetadata metadata */ 1:
                    message.metadata = UnitMetadata.internalBinaryRead(reader, reader.uint32(), options, message.metadata);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PetStats, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.UnitMetadata metadata = 1; */
        if (message.metadata)
            UnitMetadata.internalBinaryWrite(message.metadata, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.PetStats
 */
export const PetStats = new PetStats$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PlayerStats$Type extends MessageType<PlayerStats> {
    constructor() {
        super("proto.PlayerStats", [
            { no: 6, name: "base_stats", kind: "message", T: () => UnitStats },
            { no: 1, name: "gear_stats", kind: "message", T: () => UnitStats },
            { no: 7, name: "talents_stats", kind: "message", T: () => UnitStats },
            { no: 8, name: "buffs_stats", kind: "message", T: () => UnitStats },
            { no: 9, name: "consumes_stats", kind: "message", T: () => UnitStats },
            { no: 2, name: "final_stats", kind: "message", T: () => UnitStats },
            { no: 3, name: "sets", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "buffs", kind: "message", T: () => IndividualBuffs },
            { no: 10, name: "metadata", kind: "message", T: () => UnitMetadata },
            { no: 12, name: "rotation_stats", kind: "message", T: () => APLStats },
            { no: 11, name: "pets", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => PetStats }
        ]);
    }
    create(value?: PartialMessage<PlayerStats>): PlayerStats {
        const message = { sets: [], pets: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<PlayerStats>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PlayerStats): PlayerStats {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.UnitStats base_stats */ 6:
                    message.baseStats = UnitStats.internalBinaryRead(reader, reader.uint32(), options, message.baseStats);
                    break;
                case /* proto.UnitStats gear_stats */ 1:
                    message.gearStats = UnitStats.internalBinaryRead(reader, reader.uint32(), options, message.gearStats);
                    break;
                case /* proto.UnitStats talents_stats */ 7:
                    message.talentsStats = UnitStats.internalBinaryRead(reader, reader.uint32(), options, message.talentsStats);
                    break;
                case /* proto.UnitStats buffs_stats */ 8:
                    message.buffsStats = UnitStats.internalBinaryRead(reader, reader.uint32(), options, message.buffsStats);
                    break;
                case /* proto.UnitStats consumes_stats */ 9:
                    message.consumesStats = UnitStats.internalBinaryRead(reader, reader.uint32(), options, message.consumesStats);
                    break;
                case /* proto.UnitStats final_stats */ 2:
                    message.finalStats = UnitStats.internalBinaryRead(reader, reader.uint32(), options, message.finalStats);
                    break;
                case /* repeated string sets */ 3:
                    message.sets.push(reader.string());
                    break;
                case /* proto.IndividualBuffs buffs */ 4:
                    message.buffs = IndividualBuffs.internalBinaryRead(reader, reader.uint32(), options, message.buffs);
                    break;
                case /* proto.UnitMetadata metadata */ 10:
                    message.metadata = UnitMetadata.internalBinaryRead(reader, reader.uint32(), options, message.metadata);
                    break;
                case /* proto.APLStats rotation_stats */ 12:
                    message.rotationStats = APLStats.internalBinaryRead(reader, reader.uint32(), options, message.rotationStats);
                    break;
                case /* repeated proto.PetStats pets */ 11:
                    message.pets.push(PetStats.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PlayerStats, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.UnitStats base_stats = 6; */
        if (message.baseStats)
            UnitStats.internalBinaryWrite(message.baseStats, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* proto.UnitStats gear_stats = 1; */
        if (message.gearStats)
            UnitStats.internalBinaryWrite(message.gearStats, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.UnitStats talents_stats = 7; */
        if (message.talentsStats)
            UnitStats.internalBinaryWrite(message.talentsStats, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* proto.UnitStats buffs_stats = 8; */
        if (message.buffsStats)
            UnitStats.internalBinaryWrite(message.buffsStats, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* proto.UnitStats consumes_stats = 9; */
        if (message.consumesStats)
            UnitStats.internalBinaryWrite(message.consumesStats, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* proto.UnitStats final_stats = 2; */
        if (message.finalStats)
            UnitStats.internalBinaryWrite(message.finalStats, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated string sets = 3; */
        for (let i = 0; i < message.sets.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.sets[i]);
        /* proto.IndividualBuffs buffs = 4; */
        if (message.buffs)
            IndividualBuffs.internalBinaryWrite(message.buffs, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* proto.UnitMetadata metadata = 10; */
        if (message.metadata)
            UnitMetadata.internalBinaryWrite(message.metadata, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* proto.APLStats rotation_stats = 12; */
        if (message.rotationStats)
            APLStats.internalBinaryWrite(message.rotationStats, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* repeated proto.PetStats pets = 11; */
        for (let i = 0; i < message.pets.length; i++)
            PetStats.internalBinaryWrite(message.pets[i], writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.PlayerStats
 */
export const PlayerStats = new PlayerStats$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PartyStats$Type extends MessageType<PartyStats> {
    constructor() {
        super("proto.PartyStats", [
            { no: 1, name: "players", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => PlayerStats }
        ]);
    }
    create(value?: PartialMessage<PartyStats>): PartyStats {
        const message = { players: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<PartyStats>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PartyStats): PartyStats {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated proto.PlayerStats players */ 1:
                    message.players.push(PlayerStats.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PartyStats, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated proto.PlayerStats players = 1; */
        for (let i = 0; i < message.players.length; i++)
            PlayerStats.internalBinaryWrite(message.players[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.PartyStats
 */
export const PartyStats = new PartyStats$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RaidStats$Type extends MessageType<RaidStats> {
    constructor() {
        super("proto.RaidStats", [
            { no: 1, name: "parties", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => PartyStats }
        ]);
    }
    create(value?: PartialMessage<RaidStats>): RaidStats {
        const message = { parties: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<RaidStats>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RaidStats): RaidStats {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated proto.PartyStats parties */ 1:
                    message.parties.push(PartyStats.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RaidStats, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated proto.PartyStats parties = 1; */
        for (let i = 0; i < message.parties.length; i++)
            PartyStats.internalBinaryWrite(message.parties[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.RaidStats
 */
export const RaidStats = new RaidStats$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TargetStats$Type extends MessageType<TargetStats> {
    constructor() {
        super("proto.TargetStats", [
            { no: 1, name: "metadata", kind: "message", T: () => UnitMetadata }
        ]);
    }
    create(value?: PartialMessage<TargetStats>): TargetStats {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<TargetStats>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TargetStats): TargetStats {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.UnitMetadata metadata */ 1:
                    message.metadata = UnitMetadata.internalBinaryRead(reader, reader.uint32(), options, message.metadata);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TargetStats, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.UnitMetadata metadata = 1; */
        if (message.metadata)
            UnitMetadata.internalBinaryWrite(message.metadata, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.TargetStats
 */
export const TargetStats = new TargetStats$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EncounterStats$Type extends MessageType<EncounterStats> {
    constructor() {
        super("proto.EncounterStats", [
            { no: 1, name: "targets", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => TargetStats }
        ]);
    }
    create(value?: PartialMessage<EncounterStats>): EncounterStats {
        const message = { targets: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<EncounterStats>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EncounterStats): EncounterStats {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated proto.TargetStats targets */ 1:
                    message.targets.push(TargetStats.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EncounterStats, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated proto.TargetStats targets = 1; */
        for (let i = 0; i < message.targets.length; i++)
            TargetStats.internalBinaryWrite(message.targets[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.EncounterStats
 */
export const EncounterStats = new EncounterStats$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ComputeStatsResult$Type extends MessageType<ComputeStatsResult> {
    constructor() {
        super("proto.ComputeStatsResult", [
            { no: 1, name: "raid_stats", kind: "message", T: () => RaidStats },
            { no: 3, name: "encounter_stats", kind: "message", T: () => EncounterStats },
            { no: 2, name: "error_result", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ComputeStatsResult>): ComputeStatsResult {
        const message = { errorResult: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ComputeStatsResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ComputeStatsResult): ComputeStatsResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.RaidStats raid_stats */ 1:
                    message.raidStats = RaidStats.internalBinaryRead(reader, reader.uint32(), options, message.raidStats);
                    break;
                case /* proto.EncounterStats encounter_stats */ 3:
                    message.encounterStats = EncounterStats.internalBinaryRead(reader, reader.uint32(), options, message.encounterStats);
                    break;
                case /* string error_result */ 2:
                    message.errorResult = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ComputeStatsResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.RaidStats raid_stats = 1; */
        if (message.raidStats)
            RaidStats.internalBinaryWrite(message.raidStats, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.EncounterStats encounter_stats = 3; */
        if (message.encounterStats)
            EncounterStats.internalBinaryWrite(message.encounterStats, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string error_result = 2; */
        if (message.errorResult !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorResult);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.ComputeStatsResult
 */
export const ComputeStatsResult = new ComputeStatsResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StatWeightsRequest$Type extends MessageType<StatWeightsRequest> {
    constructor() {
        super("proto.StatWeightsRequest", [
            { no: 1, name: "player", kind: "message", T: () => Player },
            { no: 2, name: "raid_buffs", kind: "message", T: () => RaidBuffs },
            { no: 3, name: "party_buffs", kind: "message", T: () => PartyBuffs },
            { no: 9, name: "debuffs", kind: "message", T: () => Debuffs },
            { no: 4, name: "encounter", kind: "message", T: () => Encounter },
            { no: 5, name: "sim_options", kind: "message", T: () => SimOptions },
            { no: 8, name: "tanks", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => UnitReference },
            { no: 6, name: "stats_to_weigh", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["proto.Stat", Stat] },
            { no: 10, name: "pseudo_stats_to_weigh", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["proto.PseudoStat", PseudoStat] },
            { no: 7, name: "ep_reference_stat", kind: "enum", T: () => ["proto.Stat", Stat] }
        ]);
    }
    create(value?: PartialMessage<StatWeightsRequest>): StatWeightsRequest {
        const message = { tanks: [], statsToWeigh: [], pseudoStatsToWeigh: [], epReferenceStat: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<StatWeightsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StatWeightsRequest): StatWeightsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.Player player */ 1:
                    message.player = Player.internalBinaryRead(reader, reader.uint32(), options, message.player);
                    break;
                case /* proto.RaidBuffs raid_buffs */ 2:
                    message.raidBuffs = RaidBuffs.internalBinaryRead(reader, reader.uint32(), options, message.raidBuffs);
                    break;
                case /* proto.PartyBuffs party_buffs */ 3:
                    message.partyBuffs = PartyBuffs.internalBinaryRead(reader, reader.uint32(), options, message.partyBuffs);
                    break;
                case /* proto.Debuffs debuffs */ 9:
                    message.debuffs = Debuffs.internalBinaryRead(reader, reader.uint32(), options, message.debuffs);
                    break;
                case /* proto.Encounter encounter */ 4:
                    message.encounter = Encounter.internalBinaryRead(reader, reader.uint32(), options, message.encounter);
                    break;
                case /* proto.SimOptions sim_options */ 5:
                    message.simOptions = SimOptions.internalBinaryRead(reader, reader.uint32(), options, message.simOptions);
                    break;
                case /* repeated proto.UnitReference tanks */ 8:
                    message.tanks.push(UnitReference.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated proto.Stat stats_to_weigh */ 6:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.statsToWeigh.push(reader.int32());
                    else
                        message.statsToWeigh.push(reader.int32());
                    break;
                case /* repeated proto.PseudoStat pseudo_stats_to_weigh */ 10:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.pseudoStatsToWeigh.push(reader.int32());
                    else
                        message.pseudoStatsToWeigh.push(reader.int32());
                    break;
                case /* proto.Stat ep_reference_stat */ 7:
                    message.epReferenceStat = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StatWeightsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.Player player = 1; */
        if (message.player)
            Player.internalBinaryWrite(message.player, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.RaidBuffs raid_buffs = 2; */
        if (message.raidBuffs)
            RaidBuffs.internalBinaryWrite(message.raidBuffs, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* proto.PartyBuffs party_buffs = 3; */
        if (message.partyBuffs)
            PartyBuffs.internalBinaryWrite(message.partyBuffs, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* proto.Debuffs debuffs = 9; */
        if (message.debuffs)
            Debuffs.internalBinaryWrite(message.debuffs, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* proto.Encounter encounter = 4; */
        if (message.encounter)
            Encounter.internalBinaryWrite(message.encounter, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* proto.SimOptions sim_options = 5; */
        if (message.simOptions)
            SimOptions.internalBinaryWrite(message.simOptions, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated proto.UnitReference tanks = 8; */
        for (let i = 0; i < message.tanks.length; i++)
            UnitReference.internalBinaryWrite(message.tanks[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated proto.Stat stats_to_weigh = 6; */
        if (message.statsToWeigh.length) {
            writer.tag(6, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.statsToWeigh.length; i++)
                writer.int32(message.statsToWeigh[i]);
            writer.join();
        }
        /* repeated proto.PseudoStat pseudo_stats_to_weigh = 10; */
        if (message.pseudoStatsToWeigh.length) {
            writer.tag(10, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.pseudoStatsToWeigh.length; i++)
                writer.int32(message.pseudoStatsToWeigh[i]);
            writer.join();
        }
        /* proto.Stat ep_reference_stat = 7; */
        if (message.epReferenceStat !== 0)
            writer.tag(7, WireType.Varint).int32(message.epReferenceStat);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.StatWeightsRequest
 */
export const StatWeightsRequest = new StatWeightsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StatWeightsResult$Type extends MessageType<StatWeightsResult> {
    constructor() {
        super("proto.StatWeightsResult", [
            { no: 1, name: "dps", kind: "message", T: () => StatWeightValues },
            { no: 4, name: "hps", kind: "message", T: () => StatWeightValues },
            { no: 2, name: "tps", kind: "message", T: () => StatWeightValues },
            { no: 3, name: "dtps", kind: "message", T: () => StatWeightValues },
            { no: 5, name: "tmi", kind: "message", T: () => StatWeightValues },
            { no: 6, name: "p_death", kind: "message", T: () => StatWeightValues }
        ]);
    }
    create(value?: PartialMessage<StatWeightsResult>): StatWeightsResult {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<StatWeightsResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StatWeightsResult): StatWeightsResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.StatWeightValues dps */ 1:
                    message.dps = StatWeightValues.internalBinaryRead(reader, reader.uint32(), options, message.dps);
                    break;
                case /* proto.StatWeightValues hps */ 4:
                    message.hps = StatWeightValues.internalBinaryRead(reader, reader.uint32(), options, message.hps);
                    break;
                case /* proto.StatWeightValues tps */ 2:
                    message.tps = StatWeightValues.internalBinaryRead(reader, reader.uint32(), options, message.tps);
                    break;
                case /* proto.StatWeightValues dtps */ 3:
                    message.dtps = StatWeightValues.internalBinaryRead(reader, reader.uint32(), options, message.dtps);
                    break;
                case /* proto.StatWeightValues tmi */ 5:
                    message.tmi = StatWeightValues.internalBinaryRead(reader, reader.uint32(), options, message.tmi);
                    break;
                case /* proto.StatWeightValues p_death */ 6:
                    message.pDeath = StatWeightValues.internalBinaryRead(reader, reader.uint32(), options, message.pDeath);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StatWeightsResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.StatWeightValues dps = 1; */
        if (message.dps)
            StatWeightValues.internalBinaryWrite(message.dps, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.StatWeightValues hps = 4; */
        if (message.hps)
            StatWeightValues.internalBinaryWrite(message.hps, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* proto.StatWeightValues tps = 2; */
        if (message.tps)
            StatWeightValues.internalBinaryWrite(message.tps, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* proto.StatWeightValues dtps = 3; */
        if (message.dtps)
            StatWeightValues.internalBinaryWrite(message.dtps, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* proto.StatWeightValues tmi = 5; */
        if (message.tmi)
            StatWeightValues.internalBinaryWrite(message.tmi, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* proto.StatWeightValues p_death = 6; */
        if (message.pDeath)
            StatWeightValues.internalBinaryWrite(message.pDeath, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.StatWeightsResult
 */
export const StatWeightsResult = new StatWeightsResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StatWeightValues$Type extends MessageType<StatWeightValues> {
    constructor() {
        super("proto.StatWeightValues", [
            { no: 1, name: "weights", kind: "message", T: () => UnitStats },
            { no: 2, name: "weights_stdev", kind: "message", T: () => UnitStats },
            { no: 3, name: "ep_values", kind: "message", T: () => UnitStats },
            { no: 4, name: "ep_values_stdev", kind: "message", T: () => UnitStats }
        ]);
    }
    create(value?: PartialMessage<StatWeightValues>): StatWeightValues {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<StatWeightValues>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StatWeightValues): StatWeightValues {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.UnitStats weights */ 1:
                    message.weights = UnitStats.internalBinaryRead(reader, reader.uint32(), options, message.weights);
                    break;
                case /* proto.UnitStats weights_stdev */ 2:
                    message.weightsStdev = UnitStats.internalBinaryRead(reader, reader.uint32(), options, message.weightsStdev);
                    break;
                case /* proto.UnitStats ep_values */ 3:
                    message.epValues = UnitStats.internalBinaryRead(reader, reader.uint32(), options, message.epValues);
                    break;
                case /* proto.UnitStats ep_values_stdev */ 4:
                    message.epValuesStdev = UnitStats.internalBinaryRead(reader, reader.uint32(), options, message.epValuesStdev);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StatWeightValues, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.UnitStats weights = 1; */
        if (message.weights)
            UnitStats.internalBinaryWrite(message.weights, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.UnitStats weights_stdev = 2; */
        if (message.weightsStdev)
            UnitStats.internalBinaryWrite(message.weightsStdev, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* proto.UnitStats ep_values = 3; */
        if (message.epValues)
            UnitStats.internalBinaryWrite(message.epValues, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* proto.UnitStats ep_values_stdev = 4; */
        if (message.epValuesStdev)
            UnitStats.internalBinaryWrite(message.epValuesStdev, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.StatWeightValues
 */
export const StatWeightValues = new StatWeightValues$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AsyncAPIResult$Type extends MessageType<AsyncAPIResult> {
    constructor() {
        super("proto.AsyncAPIResult", [
            { no: 1, name: "progress_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AsyncAPIResult>): AsyncAPIResult {
        const message = { progressId: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AsyncAPIResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AsyncAPIResult): AsyncAPIResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string progress_id */ 1:
                    message.progressId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AsyncAPIResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string progress_id = 1; */
        if (message.progressId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.progressId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.AsyncAPIResult
 */
export const AsyncAPIResult = new AsyncAPIResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProgressMetrics$Type extends MessageType<ProgressMetrics> {
    constructor() {
        super("proto.ProgressMetrics", [
            { no: 1, name: "completed_iterations", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "total_iterations", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "completed_sims", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "total_sims", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "presim_running", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "dps", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "hps", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "final_raid_result", kind: "message", T: () => RaidSimResult },
            { no: 7, name: "final_weight_result", kind: "message", T: () => StatWeightsResult },
            { no: 10, name: "final_bulk_result", kind: "message", T: () => BulkSimResult }
        ]);
    }
    create(value?: PartialMessage<ProgressMetrics>): ProgressMetrics {
        const message = { completedIterations: 0, totalIterations: 0, completedSims: 0, totalSims: 0, presimRunning: false, dps: 0, hps: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ProgressMetrics>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProgressMetrics): ProgressMetrics {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 completed_iterations */ 1:
                    message.completedIterations = reader.int32();
                    break;
                case /* int32 total_iterations */ 2:
                    message.totalIterations = reader.int32();
                    break;
                case /* int32 completed_sims */ 3:
                    message.completedSims = reader.int32();
                    break;
                case /* int32 total_sims */ 4:
                    message.totalSims = reader.int32();
                    break;
                case /* bool presim_running */ 8:
                    message.presimRunning = reader.bool();
                    break;
                case /* double dps */ 5:
                    message.dps = reader.double();
                    break;
                case /* double hps */ 9:
                    message.hps = reader.double();
                    break;
                case /* proto.RaidSimResult final_raid_result */ 6:
                    message.finalRaidResult = RaidSimResult.internalBinaryRead(reader, reader.uint32(), options, message.finalRaidResult);
                    break;
                case /* proto.StatWeightsResult final_weight_result */ 7:
                    message.finalWeightResult = StatWeightsResult.internalBinaryRead(reader, reader.uint32(), options, message.finalWeightResult);
                    break;
                case /* proto.BulkSimResult final_bulk_result */ 10:
                    message.finalBulkResult = BulkSimResult.internalBinaryRead(reader, reader.uint32(), options, message.finalBulkResult);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProgressMetrics, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 completed_iterations = 1; */
        if (message.completedIterations !== 0)
            writer.tag(1, WireType.Varint).int32(message.completedIterations);
        /* int32 total_iterations = 2; */
        if (message.totalIterations !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalIterations);
        /* int32 completed_sims = 3; */
        if (message.completedSims !== 0)
            writer.tag(3, WireType.Varint).int32(message.completedSims);
        /* int32 total_sims = 4; */
        if (message.totalSims !== 0)
            writer.tag(4, WireType.Varint).int32(message.totalSims);
        /* bool presim_running = 8; */
        if (message.presimRunning !== false)
            writer.tag(8, WireType.Varint).bool(message.presimRunning);
        /* double dps = 5; */
        if (message.dps !== 0)
            writer.tag(5, WireType.Bit64).double(message.dps);
        /* double hps = 9; */
        if (message.hps !== 0)
            writer.tag(9, WireType.Bit64).double(message.hps);
        /* proto.RaidSimResult final_raid_result = 6; */
        if (message.finalRaidResult)
            RaidSimResult.internalBinaryWrite(message.finalRaidResult, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* proto.StatWeightsResult final_weight_result = 7; */
        if (message.finalWeightResult)
            StatWeightsResult.internalBinaryWrite(message.finalWeightResult, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* proto.BulkSimResult final_bulk_result = 10; */
        if (message.finalBulkResult)
            BulkSimResult.internalBinaryWrite(message.finalBulkResult, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.ProgressMetrics
 */
export const ProgressMetrics = new ProgressMetrics$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkSimRequest$Type extends MessageType<BulkSimRequest> {
    constructor() {
        super("proto.BulkSimRequest", [
            { no: 1, name: "base_settings", kind: "message", T: () => RaidSimRequest },
            { no: 2, name: "bulk_settings", kind: "message", T: () => BulkSettings }
        ]);
    }
    create(value?: PartialMessage<BulkSimRequest>): BulkSimRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<BulkSimRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkSimRequest): BulkSimRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.RaidSimRequest base_settings */ 1:
                    message.baseSettings = RaidSimRequest.internalBinaryRead(reader, reader.uint32(), options, message.baseSettings);
                    break;
                case /* proto.BulkSettings bulk_settings */ 2:
                    message.bulkSettings = BulkSettings.internalBinaryRead(reader, reader.uint32(), options, message.bulkSettings);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkSimRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.RaidSimRequest base_settings = 1; */
        if (message.baseSettings)
            RaidSimRequest.internalBinaryWrite(message.baseSettings, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.BulkSettings bulk_settings = 2; */
        if (message.bulkSettings)
            BulkSettings.internalBinaryWrite(message.bulkSettings, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.BulkSimRequest
 */
export const BulkSimRequest = new BulkSimRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkSettings$Type extends MessageType<BulkSettings> {
    constructor() {
        super("proto.BulkSettings", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ItemSpec },
            { no: 2, name: "combinations", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "fast_mode", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "auto_enchant", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "auto_gem", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "default_red_gem", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "default_blue_gem", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "default_yellow_gem", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "default_meta_gem", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "ensure_meta_req_met", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "iterations_per_combo", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<BulkSettings>): BulkSettings {
        const message = { items: [], combinations: false, fastMode: false, autoEnchant: false, autoGem: false, defaultRedGem: 0, defaultBlueGem: 0, defaultYellowGem: 0, defaultMetaGem: 0, ensureMetaReqMet: false, iterationsPerCombo: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<BulkSettings>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkSettings): BulkSettings {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated proto.ItemSpec items */ 1:
                    message.items.push(ItemSpec.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool combinations */ 2:
                    message.combinations = reader.bool();
                    break;
                case /* bool fast_mode */ 3:
                    message.fastMode = reader.bool();
                    break;
                case /* bool auto_enchant */ 4:
                    message.autoEnchant = reader.bool();
                    break;
                case /* bool auto_gem */ 5:
                    message.autoGem = reader.bool();
                    break;
                case /* int32 default_red_gem */ 6:
                    message.defaultRedGem = reader.int32();
                    break;
                case /* int32 default_blue_gem */ 7:
                    message.defaultBlueGem = reader.int32();
                    break;
                case /* int32 default_yellow_gem */ 8:
                    message.defaultYellowGem = reader.int32();
                    break;
                case /* int32 default_meta_gem */ 9:
                    message.defaultMetaGem = reader.int32();
                    break;
                case /* bool ensure_meta_req_met */ 10:
                    message.ensureMetaReqMet = reader.bool();
                    break;
                case /* int32 iterations_per_combo */ 11:
                    message.iterationsPerCombo = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkSettings, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated proto.ItemSpec items = 1; */
        for (let i = 0; i < message.items.length; i++)
            ItemSpec.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool combinations = 2; */
        if (message.combinations !== false)
            writer.tag(2, WireType.Varint).bool(message.combinations);
        /* bool fast_mode = 3; */
        if (message.fastMode !== false)
            writer.tag(3, WireType.Varint).bool(message.fastMode);
        /* bool auto_enchant = 4; */
        if (message.autoEnchant !== false)
            writer.tag(4, WireType.Varint).bool(message.autoEnchant);
        /* bool auto_gem = 5; */
        if (message.autoGem !== false)
            writer.tag(5, WireType.Varint).bool(message.autoGem);
        /* int32 default_red_gem = 6; */
        if (message.defaultRedGem !== 0)
            writer.tag(6, WireType.Varint).int32(message.defaultRedGem);
        /* int32 default_blue_gem = 7; */
        if (message.defaultBlueGem !== 0)
            writer.tag(7, WireType.Varint).int32(message.defaultBlueGem);
        /* int32 default_yellow_gem = 8; */
        if (message.defaultYellowGem !== 0)
            writer.tag(8, WireType.Varint).int32(message.defaultYellowGem);
        /* int32 default_meta_gem = 9; */
        if (message.defaultMetaGem !== 0)
            writer.tag(9, WireType.Varint).int32(message.defaultMetaGem);
        /* bool ensure_meta_req_met = 10; */
        if (message.ensureMetaReqMet !== false)
            writer.tag(10, WireType.Varint).bool(message.ensureMetaReqMet);
        /* int32 iterations_per_combo = 11; */
        if (message.iterationsPerCombo !== 0)
            writer.tag(11, WireType.Varint).int32(message.iterationsPerCombo);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.BulkSettings
 */
export const BulkSettings = new BulkSettings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkSimResult$Type extends MessageType<BulkSimResult> {
    constructor() {
        super("proto.BulkSimResult", [
            { no: 1, name: "results", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => BulkComboResult },
            { no: 2, name: "equipped_gear_result", kind: "message", T: () => BulkComboResult },
            { no: 3, name: "error_result", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<BulkSimResult>): BulkSimResult {
        const message = { results: [], errorResult: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<BulkSimResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkSimResult): BulkSimResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated proto.BulkComboResult results */ 1:
                    message.results.push(BulkComboResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* proto.BulkComboResult equipped_gear_result */ 2:
                    message.equippedGearResult = BulkComboResult.internalBinaryRead(reader, reader.uint32(), options, message.equippedGearResult);
                    break;
                case /* string error_result */ 3:
                    message.errorResult = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkSimResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated proto.BulkComboResult results = 1; */
        for (let i = 0; i < message.results.length; i++)
            BulkComboResult.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.BulkComboResult equipped_gear_result = 2; */
        if (message.equippedGearResult)
            BulkComboResult.internalBinaryWrite(message.equippedGearResult, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string error_result = 3; */
        if (message.errorResult !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.errorResult);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.BulkSimResult
 */
export const BulkSimResult = new BulkSimResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkComboResult$Type extends MessageType<BulkComboResult> {
    constructor() {
        super("proto.BulkComboResult", [
            { no: 1, name: "items_added", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ItemSpecWithSlot },
            { no: 2, name: "unit_metrics", kind: "message", T: () => UnitMetrics }
        ]);
    }
    create(value?: PartialMessage<BulkComboResult>): BulkComboResult {
        const message = { itemsAdded: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<BulkComboResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkComboResult): BulkComboResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated proto.ItemSpecWithSlot items_added */ 1:
                    message.itemsAdded.push(ItemSpecWithSlot.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* proto.UnitMetrics unit_metrics */ 2:
                    message.unitMetrics = UnitMetrics.internalBinaryRead(reader, reader.uint32(), options, message.unitMetrics);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkComboResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated proto.ItemSpecWithSlot items_added = 1; */
        for (let i = 0; i < message.itemsAdded.length; i++)
            ItemSpecWithSlot.internalBinaryWrite(message.itemsAdded[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.UnitMetrics unit_metrics = 2; */
        if (message.unitMetrics)
            UnitMetrics.internalBinaryWrite(message.unitMetrics, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.BulkComboResult
 */
export const BulkComboResult = new BulkComboResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ItemSpecWithSlot$Type extends MessageType<ItemSpecWithSlot> {
    constructor() {
        super("proto.ItemSpecWithSlot", [
            { no: 1, name: "item", kind: "message", T: () => ItemSpec },
            { no: 2, name: "slot", kind: "enum", T: () => ["proto.ItemSlot", ItemSlot] }
        ]);
    }
    create(value?: PartialMessage<ItemSpecWithSlot>): ItemSpecWithSlot {
        const message = { slot: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ItemSpecWithSlot>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ItemSpecWithSlot): ItemSpecWithSlot {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.ItemSpec item */ 1:
                    message.item = ItemSpec.internalBinaryRead(reader, reader.uint32(), options, message.item);
                    break;
                case /* proto.ItemSlot slot */ 2:
                    message.slot = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ItemSpecWithSlot, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.ItemSpec item = 1; */
        if (message.item)
            ItemSpec.internalBinaryWrite(message.item, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.ItemSlot slot = 2; */
        if (message.slot !== 0)
            writer.tag(2, WireType.Varint).int32(message.slot);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.ItemSpecWithSlot
 */
export const ItemSpecWithSlot = new ItemSpecWithSlot$Type();
